// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* AuditOS Styles */
.audit-layout {
  display: grid;
  grid-template-columns: 15.5rem 1fr 22rem;
  grid-template-rows: auto 1fr;
  height: 100vh;
  overflow: hidden;
  background:
    radial-gradient(circle at top left, rgba(99, 102, 241, 0.2), transparent 22%),
    radial-gradient(circle at top right, rgba(34, 211, 238, 0.14), transparent 24%),
    linear-gradient(180deg, #eef2ff 0%, #e0f2fe 100%);
  font-family: "Manrope", "Segoe UI", Arial, sans-serif;
}

.audit-layout.chat-closed {
  grid-template-columns: 15.5rem 1fr 0;
}

.audit-sidebar {
  grid-row: 1 / -1;
  grid-column: 1;
}

.sidebar-enter {
  animation: sidebarIn 500ms cubic-bezier(0.2, 0.9, 0.2, 1) both;
}

.audit-sidebar {
  background:
    radial-gradient(circle at top left, rgba(99, 102, 241, 0.14), transparent 24%),
    linear-gradient(180deg, rgba(255, 255, 255, 0.92) 0%, rgba(244, 247, 255, 0.96) 48%, rgba(236, 242, 255, 0.98) 100%);
}

.audit-brand {
  position: relative;
}

.audit-brand::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 3px;
  background: linear-gradient(90deg, #6366f1, #22d3ee, #a78bfa);
  opacity: 0.95;
}

.audit-panel {
  background: linear-gradient(180deg, rgba(255, 255, 255, 0.52), rgba(255, 255, 255, 0.18));
}

.audit-active-audit {
  background: rgba(255, 255, 255, 0.55);
  border: 1px solid rgba(148, 163, 184, 0.18);
  border-radius: 10px;
  padding: 6px 8px;
  display: flex;
  align-items: center;
  gap: 6px;
}

.audit-health-pulse {
  width: 7px;
  height: 7px;
  border-radius: 999px;
  display: inline-block;
  animation: healthPulse 1.9s ease-in-out infinite;
}

.audit-health-pulse.good {
  background: #22c55e;
  --pulse-color: rgba(34, 197, 94, 0.45);
}

.audit-health-pulse.warn {
  background: #f59e0b;
  --pulse-color: rgba(245, 158, 11, 0.45);
}

.audit-health-pulse.risk {
  background: #ef4444;
  --pulse-color: rgba(239, 68, 68, 0.45);
}

.section-dot {
  width: 4px;
  height: 4px;
  border-radius: 999px;
  background: #2563eb;
  box-shadow: 0 0 10px rgba(37, 99, 235, 0.55);
}

.audit-chip {
  color: #cbd5e1;
  border: 1px solid transparent;
  background: rgba(255, 255, 255, 0.02);
}

.audit-chip:hover {
  background: rgba(255, 255, 255, 0.07);
}

.audit-chip.active {
  background: rgba(37, 99, 235, 0.16);
  border-color: rgba(37, 99, 235, 0.45);
  color: #eff6ff;
  box-shadow: inset 0 0 0 1px rgba(37, 99, 235, 0.22);
}

.audit-header {
  grid-row: 1;
  grid-column: 2;
}

.audit-main {
  grid-row: 2;
  grid-column: 2;
  overflow-y: auto;
  position: relative;
  background:
    radial-gradient(circle at top right, rgba(129, 140, 248, 0.18), transparent 22%),
    radial-gradient(circle at top left, rgba(34, 211, 238, 0.1), transparent 20%),
    linear-gradient(180deg, #f7fbff 0%, #eef2ff 100%);
  box-shadow:
    inset 1px 0 0 #c7d2fe,
    inset -1px 0 0 #c7d2fe,
    inset 0 -1px 0 #c7d2fe;
}

.audit-main::before {
  content: "";
  position: absolute;
  inset: 0 0 auto 0;
  height: 196px;
  background:
    radial-gradient(circle at top right, rgba(34, 211, 238, 0.22), transparent 30%),
    linear-gradient(120deg, #1d4ed8 0%, #4f46e5 46%, #7c3aed 100%);
  z-index: 0;
}

.audit-main > * {
  position: relative;
  z-index: 1;
}

.dark .audit-main {
  background: #121722;
  box-shadow:
    inset 1px 0 0 #292f3b,
    inset -1px 0 0 #292f3b,
    inset 0 -1px 0 #292f3b;
}

.dark .audit-main::before {
  background:
    radial-gradient(circle at top right, rgba(34, 211, 238, 0.14), transparent 28%),
    linear-gradient(120deg, #1e3a8a 0%, #4f46e5 42%, #0b1220 100%);
}

.dark .audit-main .bg-card,
.dark .audit-main [class*="bg-card/"],
.dark .audit-main .bg-background {
  background-color: hsl(var(--card)) !important;
}

.audit-chat {
  grid-row: 1 / -1;
  grid-column: 3;
  transition: width 200ms ease;
  border-left: 1px solid hsl(var(--border));
  background: linear-gradient(180deg, rgba(255, 255, 255, 0.94) 0%, rgba(238, 242, 255, 0.98) 100%);
}

/* Phase progress */
.phase-step {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  flex: 1 1;
}

.phase-step-dot {
  width: 28px;
  height: 28px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 11px;
  font-weight: 600;
  z-index: 1;
  transition: all 200ms ease;
  animation: phaseDotIn 420ms cubic-bezier(0.2, 0.9, 0.2, 1) both;
  animation-delay: var(--phase-delay, 0ms);
}

.phase-step-line {
  position: absolute;
  top: 14px;
  left: 50%;
  width: 100%;
  height: 2px;
  z-index: 0;
  background: hsl(var(--border));
  overflow: hidden;
}

.phase-step-line::after {
  content: "";
  position: absolute;
  inset: 0;
  transform-origin: left center;
  transform: scaleX(0);
  background: linear-gradient(90deg, hsl(var(--primary)), hsl(var(--chart-2)));
}

.phase-step-line.is-active::after {
  animation: progressGrow 900ms cubic-bezier(0.2, 0.8, 0.2, 1) both;
  animation-delay: calc(var(--phase-delay, 0ms) + 120ms);
}

.phase-step-button:hover .phase-step-dot {
  transform: translateY(-2px) scale(1.04);
  box-shadow: 0 0 0 6px rgba(99, 102, 241, 0.08);
}

.phase-step-dot.is-current {
  box-shadow: 0 0 0 6px rgba(99, 102, 241, 0.12), 0 0 22px rgba(99, 102, 241, 0.26);
  animation:
    phaseDotIn 420ms cubic-bezier(0.2, 0.9, 0.2, 1) both,
    currentPhasePulse 2.6s ease-in-out infinite;
  animation-delay: var(--phase-delay, 0ms), calc(var(--phase-delay, 0ms) + 420ms);
}

.phase-step-dot.is-complete {
  box-shadow: 0 0 0 4px rgba(16, 185, 129, 0.1);
}

.phase-progress-shell .phase-step span {
  animation: rowIn 320ms ease both;
  animation-delay: calc(var(--phase-delay, 0ms) + 120ms);
}

/* Labels */
.label-xs {
  font-size: 10px;
  font-weight: 600;
  letter-spacing: 0.1em;
  text-transform: uppercase;
}

/* Data table density */
.table-dense th,
.table-dense td {
  padding: 0.5rem 0.75rem;
  font-size: 0.8125rem;
}

.table-dense th {
  font-size: 0.6875rem;
  text-transform: uppercase;
  letter-spacing: 0.05em;
}

/* Severity badges */
.severity-high {
  --tw-border-opacity: 1;
  border-color: rgb(254 202 202 / var(--tw-border-opacity, 1));
  --tw-bg-opacity: 1;
  background-color: rgb(254 242 242 / var(--tw-bg-opacity, 1));
  --tw-text-opacity: 1;
  color: rgb(185 28 28 / var(--tw-text-opacity, 1));
}
.severity-high:is(.dark *) {
  --tw-border-opacity: 1;
  border-color: rgb(127 29 29 / var(--tw-border-opacity, 1));
  background-color: rgb(69 10 10 / 0.3);
  --tw-text-opacity: 1;
  color: rgb(248 113 113 / var(--tw-text-opacity, 1));
}
.severity-medium {
  --tw-border-opacity: 1;
  border-color: rgb(253 230 138 / var(--tw-border-opacity, 1));
  --tw-bg-opacity: 1;
  background-color: rgb(255 251 235 / var(--tw-bg-opacity, 1));
  --tw-text-opacity: 1;
  color: rgb(180 83 9 / var(--tw-text-opacity, 1));
}
.severity-medium:is(.dark *) {
  --tw-border-opacity: 1;
  border-color: rgb(120 53 15 / var(--tw-border-opacity, 1));
  background-color: rgb(69 26 3 / 0.3);
  --tw-text-opacity: 1;
  color: rgb(251 191 36 / var(--tw-text-opacity, 1));
}
.severity-low {
  --tw-border-opacity: 1;
  border-color: rgb(191 219 254 / var(--tw-border-opacity, 1));
  --tw-bg-opacity: 1;
  background-color: rgb(239 246 255 / var(--tw-bg-opacity, 1));
  --tw-text-opacity: 1;
  color: rgb(29 78 216 / var(--tw-text-opacity, 1));
}
.severity-low:is(.dark *) {
  --tw-border-opacity: 1;
  border-color: rgb(30 58 138 / var(--tw-border-opacity, 1));
  background-color: rgb(23 37 84 / 0.3);
  --tw-text-opacity: 1;
  color: rgb(96 165 250 / var(--tw-text-opacity, 1));
}
.severity-observation {
  --tw-border-opacity: 1;
  border-color: rgb(226 232 240 / var(--tw-border-opacity, 1));
  --tw-bg-opacity: 1;
  background-color: rgb(248 250 252 / var(--tw-bg-opacity, 1));
  --tw-text-opacity: 1;
  color: rgb(51 65 85 / var(--tw-text-opacity, 1));
}
.severity-observation:is(.dark *) {
  --tw-border-opacity: 1;
  border-color: rgb(15 23 42 / var(--tw-border-opacity, 1));
  background-color: rgb(2 6 23 / 0.3);
  --tw-text-opacity: 1;
  color: rgb(148 163 184 / var(--tw-text-opacity, 1));
}

/* Status indicators */
.status-dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  display: inline-block;
}

.status-ready {
  --tw-bg-opacity: 1;
  background-color: rgb(16 185 129 / var(--tw-bg-opacity, 1));
}
@keyframes pulse {
  50% {
    opacity: .5;
  }
}
.status-ingesting {
  animation: pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite;
  --tw-bg-opacity: 1;
  background-color: rgb(245 158 11 / var(--tw-bg-opacity, 1));
}
@keyframes pulse {
  50% {
    opacity: .5;
  }
}
.status-parsing {
  animation: pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite;
  --tw-bg-opacity: 1;
  background-color: rgb(59 130 246 / var(--tw-bg-opacity, 1));
}
@keyframes pulse {
  50% {
    opacity: .5;
  }
}
.status-extracting {
  animation: pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite;
  --tw-bg-opacity: 1;
  background-color: rgb(139 92 246 / var(--tw-bg-opacity, 1));
}
.status-uploaded {
  --tw-bg-opacity: 1;
  background-color: rgb(148 163 184 / var(--tw-bg-opacity, 1));
}

/* Chat message animation */
@keyframes fadeInUp {
  from { opacity: 0; transform: translateY(8px); }
  to { opacity: 1; transform: translateY(0); }
}

.chat-message-enter {
  animation: fadeInUp 200ms ease-out;
}

/* Ambient Motion Layer */
.ambient-canvas {
  position: relative;
  isolation: isolate;
}

.audit-main .ambient-orb,
.audit-main .ambient-particles {
  display: block;
}

/* Keep dashboard content white over the orange surface */
.audit-main .bg-card,
.audit-main [class*="bg-card/"],
.audit-main .bg-background {
  background-color: #ffffff !important;
}

.audit-main .border {
  border-color: rgba(129, 140, 248, 0.28);
}

/* Make top phase header text readable over the dark-teal hero strip */
.audit-main [data-testid^="phase-"] > div:first-child h2 {
  color: #ffffff !important;
  text-shadow: 0 1px 1px rgba(2, 6, 23, 0.4);
}

.audit-main [data-testid^="phase-"] > div:first-child p {
  color: #dbeafe !important;
}

.audit-main [data-testid^="phase-"] {
  animation: phasePageIn 560ms cubic-bezier(0.2, 0.9, 0.2, 1) both;
}

.audit-main [data-testid^="phase-"] > * {
  animation: phaseSectionIn 520ms cubic-bezier(0.2, 0.9, 0.2, 1) both;
}

.audit-main [data-testid^="phase-"] > *:nth-child(1) { animation-delay: 40ms; }
.audit-main [data-testid^="phase-"] > *:nth-child(2) { animation-delay: 110ms; }
.audit-main [data-testid^="phase-"] > *:nth-child(3) { animation-delay: 180ms; }
.audit-main [data-testid^="phase-"] > *:nth-child(4) { animation-delay: 250ms; }
.audit-main [data-testid^="phase-"] > *:nth-child(5) { animation-delay: 320ms; }

/* Phase 7 command-center treatment */
.phase7-hero {
  position: relative;
  isolation: isolate;
  border-color: rgba(129, 140, 248, 0.28);
  background:
    linear-gradient(135deg, rgba(15, 23, 42, 0.98) 0%, rgba(15, 23, 42, 0.94) 48%, rgba(30, 27, 75, 0.96) 100%),
    radial-gradient(circle at 12% 0%, rgba(45, 212, 191, 0.28), transparent 28%),
    radial-gradient(circle at 88% 18%, rgba(129, 140, 248, 0.24), transparent 34%);
  box-shadow: 0 24px 60px rgba(2, 6, 23, 0.32), inset 0 1px 0 rgba(255, 255, 255, 0.08);
  animation: heroGradientDrift 14s ease-in-out infinite alternate;
}

.phase7-hero::after {
  content: "";
  position: absolute;
  inset: 0;
  z-index: -1;
  background-image:
    linear-gradient(rgba(148, 163, 184, 0.08) 1px, transparent 1px),
    linear-gradient(90deg, rgba(148, 163, 184, 0.08) 1px, transparent 1px);
  background-size: 44px 44px;
  mask-image: linear-gradient(180deg, black, transparent 78%);
}

.phase7-hero p,
.phase7-hero h2 {
  color: inherit !important;
}

.phase7-hero .text-slate-300 {
  color: #cbd5e1 !important;
}

.phase7-hero .text-slate-400 {
  color: #94a3b8 !important;
}

.phase7-hero .text-cyan-200\\/90 {
  color: rgba(165, 243, 252, 0.9) !important;
}

.phase7-stat {
  backdrop-filter: blur(10px);
  transition: transform 180ms ease, border-color 180ms ease, background 180ms ease;
}

.phase7-stat:hover {
  transform: translateY(-2px);
  border-color: rgba(45, 212, 191, 0.36);
  background: rgba(255, 255, 255, 0.09);
}

.phase7-console-card,
.phase7-control-row,
.phase7-progress-card {
  animation: phaseSectionIn 480ms cubic-bezier(0.2, 0.9, 0.2, 1) both;
}

.phase7-console-card {
  overflow: hidden;
  box-shadow: 0 18px 42px rgba(2, 6, 23, 0.08);
}

.dark .phase7-console-card {
  background:
    linear-gradient(180deg, rgba(23, 29, 46, 0.94), rgba(15, 23, 42, 0.96)) !important;
  border-color: rgba(129, 140, 248, 0.22) !important;
  box-shadow: 0 22px 46px rgba(0, 0, 0, 0.26), inset 0 1px 0 rgba(255, 255, 255, 0.04);
}

.dark .phase7-control-panel,
.dark .phase7-progress-card {
  background: rgba(2, 6, 23, 0.28) !important;
  border-color: rgba(148, 163, 184, 0.18) !important;
}

.dark .phase7-control-row {
  background: rgba(15, 23, 42, 0.72) !important;
  border-color: rgba(148, 163, 184, 0.16) !important;
}

.dark .phase7-control-row:hover {
  border-color: rgba(45, 212, 191, 0.34) !important;
}

/* Phase 10 readability on orange + white dashboard */
.phase10-readable,
.phase10-readable * {
  color: #0f172a;
}

.phase10-readable .text-muted-foreground {
  color: #111827 !important;
}

.phase10-readable .text-\\[10px\\],
.phase10-readable .text-\\[9px\\],
.phase10-readable .text-\\[8px\\] {
  color: #1f2937 !important;
}

.phase10-no-gap {
  margin: -24px -24px 0;
  padding: 0 8px 24px;
}

.phase10-report-header {
  margin: 0 -8px;
  padding: 18px 20px;
  border: 1px solid rgba(129, 140, 248, 0.24);
  border-radius: 18px;
  background:
    radial-gradient(circle at top right, rgba(34, 211, 238, 0.16), transparent 30%),
    linear-gradient(120deg, #1e3a8a 0%, #4f46e5 42%, #111827 100%);
  box-shadow: 0 18px 42px rgba(2, 6, 23, 0.22);
}

.phase10-report-header-attached {
  border-bottom-color: rgba(255, 255, 255, 0.08);
  border-bottom-right-radius: 0;
  border-bottom-left-radius: 0;
}

.phase10-report-header .bg-white\\/80,
.phase10-report-header [class*="bg-card"],
.phase10-report-header [class*="bg-background"] {
  background-color: rgba(15, 23, 42, 0.72) !important;
}

.phase10-report-header button,
.phase10-report-header [role="combobox"] {
  border-color: rgba(255, 255, 255, 0.18) !important;
  color: #ffffff;
}

.phase10-report-header button:hover,
.phase10-report-header [role="combobox"]:hover {
  background-color: rgba(255, 255, 255, 0.12) !important;
}

.phase10-command-brief {
  margin-top: -1.5rem !important;
  border-top-right-radius: 0 !important;
  border-top-left-radius: 0 !important;
}

.ambient-orb {
  position: fixed;
  pointer-events: none;
  z-index: 0;
  filter: blur(34px);
  opacity: 0.2;
  border-radius: 9999px;
  animation: orbFloat 10s ease-in-out infinite alternate;
}

.orb-one {
  width: 280px;
  height: 280px;
  right: 14%;
  top: 18%;
  background: radial-gradient(circle, rgba(37,99,235,0.35) 0%, rgba(37,99,235,0) 70%);
}

.orb-two {
  width: 220px;
  height: 220px;
  right: 34%;
  bottom: 8%;
  background: radial-gradient(circle, rgba(96,165,250,0.28) 0%, rgba(96,165,250,0) 70%);
  animation-delay: 1.2s;
}

.ambient-particles {
  position: fixed;
  inset: 0;
  pointer-events: none;
  z-index: 0;
  background-image:
    radial-gradient(circle at 10% 18%, rgba(96,165,250,0.22) 1px, transparent 1.6px),
    radial-gradient(circle at 70% 35%, rgba(37,99,235,0.18) 1px, transparent 1.6px),
    radial-gradient(circle at 35% 72%, rgba(147,197,253,0.16) 1px, transparent 1.6px);
  background-size: 320px 320px, 260px 260px, 380px 380px;
  animation: particlesDrift 16s linear infinite;
  display: none;
}

/* Sidebar and Nav Animations */
.sidebar-logo-anim {
  transform-origin: center;
  transition: transform 220ms cubic-bezier(0.2, 0.8, 0.2, 1);
}

.sidebar-logo-anim:hover {
  transform: rotate(-7deg) scale(1.06);
}

.sidebar-nav-item {
  position: relative;
  overflow: hidden;
  animation: navItemIn 420ms cubic-bezier(0.2, 0.9, 0.2, 1) both;
  animation-delay: var(--stagger, 0ms);
  transition: transform 170ms ease, box-shadow 170ms ease;
}

.sidebar-nav-item:hover {
  transform: translateX(3px);
}

.sidebar-nav-item .nav-icon {
  transition: transform 180ms ease, color 180ms ease;
}

.sidebar-nav-item:hover .nav-icon {
  transform: scale(1.08);
  color: #60a5fa;
}

.sidebar-nav-item.active::before {
  content: "";
  position: absolute;
  left: 0;
  top: 18%;
  height: 64%;
  width: 3px;
  border-radius: 999px;
  background: #2563eb;
  box-shadow: 0 0 12px rgba(37, 99, 235, 0.55);
}

.sidebar-stepper {
  position: relative;
}

.sidebar-stepper::before {
  content: "";
  position: absolute;
  left: 18px;
  top: 44px;
  bottom: 18px;
  width: 1px;
  background: linear-gradient(180deg, rgba(255, 255, 255, 0.08), rgba(37, 99, 235, 0.45), rgba(255, 255, 255, 0.08));
}

.sidebar-stepper .sidebar-nav-item {
  padding-left: 0.95rem;
}

.sidebar-journey-progress {
  background: linear-gradient(90deg, #6366f1 0%, #8b5cf6 50%, #a855f7 100%);
  box-shadow: 0 0 14px rgba(139, 92, 246, 0.35);
  transition: width 260ms ease;
}

.sidebar-stepper .sidebar-nav-item .ml-auto {
  height: 7px;
  width: 7px;
  border-radius: 999px;
  background: #8b5cf6;
  box-shadow: 0 0 10px rgba(139, 92, 246, 0.55);
}

.sidebar-stepper .sidebar-nav-item.is-complete .nav-icon {
  color: #c4b5fd;
}

.sidebar-profile-avatar {
  box-shadow: 0 0 0 1px rgba(99, 102, 241, 0.12), 0 8px 20px rgba(30, 41, 59, 0.18);
}

.profile-summary-avatar {
  box-shadow: 0 0 0 1px rgba(99, 102, 241, 0.12), 0 10px 24px rgba(30, 41, 59, 0.2);
}

/* Quick Action Micro-Interaction */
.quick-action {
  transition: transform 160ms ease, color 160ms ease;
}

.quick-action:hover {
  transform: translateX(4px);
}

/* Metric Card Entrance + Hover Lift */
.metric-card-anim {
  position: relative;
  overflow: hidden;
  animation: metricIn 580ms cubic-bezier(0.2, 0.9, 0.15, 1.1) both;
  animation-delay: var(--delay, 0ms);
  transition: transform 180ms ease, box-shadow 180ms ease;
}

.metric-card-anim::after {
  content: "";
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  height: 2px;
  background: linear-gradient(90deg, rgba(37,99,235,0), rgba(37,99,235,0.85), rgba(37,99,235,0));
  opacity: 0;
  transform: translateY(2px);
  transition: opacity 180ms ease, transform 180ms ease;
}

.metric-card-anim:hover {
  transform: translateY(-3px);
  box-shadow: 0 8px 18px rgba(15, 23, 42, 0.08);
}

.metric-card-anim:hover::after {
  opacity: 1;
  transform: translateY(0);
}

.audit-card {
  position: relative;
  overflow: hidden;
}

.audit-card::before {
  content: "";
  position: absolute;
  inset: 0;
  background: linear-gradient(115deg, transparent 0%, rgba(255, 255, 255, 0.08) 18%, transparent 36%);
  opacity: 0;
  transform: translateX(-18%);
  transition: opacity 220ms ease, transform 420ms ease;
  pointer-events: none;
}

.audit-card:hover::before {
  opacity: 1;
  transform: translateX(18%);
}

.dark .audit-card:hover {
  box-shadow: 0 24px 50px rgba(2, 6, 23, 0.34), inset 0 1px 0 rgba(255, 255, 255, 0.03);
}

.executive-glass {
  background: linear-gradient(140deg, rgba(255, 255, 255, 0.86), rgba(255, 245, 236, 0.72)) !important;
  border: 1px solid rgba(37, 99, 235, 0.18) !important;
  box-shadow: 0 16px 34px rgba(37, 99, 235, 0.08), inset 0 1px 0 rgba(255, 255, 255, 0.55);
  backdrop-filter: blur(10px);
}

.dark .executive-glass {
  background: linear-gradient(140deg, rgba(26, 26, 27, 0.72), rgba(17, 24, 39, 0.55)) !important;
  border-color: rgba(45, 212, 191, 0.35) !important;
  box-shadow: 0 10px 28px rgba(0, 0, 0, 0.38), inset 0 1px 0 rgba(255, 255, 255, 0.05);
}

.executive-hero {
  background: linear-gradient(120deg, #1d4ed8 0%, #2563eb 52%, #60a5fa 100%) !important;
  box-shadow: 0 16px 30px rgba(29, 78, 216, 0.18);
}

.hero-progress-wrap {
  min-width: 250px;
  background: rgba(255, 255, 255, 0.18);
  border: 1px solid rgba(255, 241, 229, 0.42);
  border-radius: 16px;
  padding: 12px;
  backdrop-filter: blur(6px);
}

.hero-progress-label {
  display: flex;
  justify-content: space-between;
  font-size: 11px;
  color: rgba(255, 255, 255, 0.95);
  font-weight: 700;
}

.hero-progress-track {
  height: 8px;
  border-radius: 999px;
  margin-top: 8px;
  background: rgba(191, 219, 254, 0.38);
  overflow: hidden;
}

.hero-progress-fill {
  height: 100%;
  border-radius: 999px;
  background: linear-gradient(90deg, #fff6ed, #ffffff);
  animation: progressGrow 900ms cubic-bezier(0.2, 0.8, 0.2, 1) both;
  position: relative;
  overflow: hidden;
}

.hero-progress-fill::after,
.quick-actions-fill::after,
.assistant-task-fill::after {
  content: "";
  position: absolute;
  inset: 0;
  background: linear-gradient(90deg, transparent 0%, rgba(255, 255, 255, 0.5) 48%, transparent 100%);
  transform: translateX(-120%);
  animation: scanSweep 1.9s ease-in-out infinite;
}

/* Table Row Reveal + Progress */
.table-row-anim {
  animation: rowIn 380ms ease both;
  animation-delay: var(--row-delay, 0ms);
}

.audit-main table tbody tr {
  animation: rowIn 420ms ease both;
}

.audit-main table tbody tr:nth-child(1) { animation-delay: 50ms; }
.audit-main table tbody tr:nth-child(2) { animation-delay: 90ms; }
.audit-main table tbody tr:nth-child(3) { animation-delay: 130ms; }
.audit-main table tbody tr:nth-child(4) { animation-delay: 170ms; }
.audit-main table tbody tr:nth-child(5) { animation-delay: 210ms; }

.progress-anim {
  transform-origin: left center;
  animation: progressGrow 900ms cubic-bezier(0.2, 0.8, 0.2, 1) both;
  animation-delay: 120ms;
}

.progress-bar-indicator {
  position: relative;
  overflow: hidden;
}

.progress-bar-indicator::after {
  content: "";
  position: absolute;
  inset: 0;
  background: linear-gradient(90deg, transparent 0%, rgba(255, 255, 255, 0.35) 45%, transparent 100%);
  transform: translateX(-125%);
  animation: scanSweep 2.1s ease-in-out infinite;
}

/* Notification Pulse */
.notification-pulse {
  animation: bellPulse 1.8s ease-in-out infinite;
}

/* Floating AI Button */
.floating-ai-btn {
  position: fixed;
  right: 1.2rem;
  bottom: 1.2rem;
  z-index: 40;
  display: inline-flex;
  align-items: center;
  gap: 0.45rem;
  border-radius: 999px;
  background: linear-gradient(135deg, #1d4ed8, #3b82f6);
  color: white;
  box-shadow: 0 16px 32px rgba(29, 78, 216, 0.28);
  animation: floatBtnIn 540ms cubic-bezier(0.2, 0.95, 0.2, 1.2) both;
}

.audit-chat-panel {
  background: linear-gradient(180deg, rgba(255, 255, 255, 0.96) 0%, rgba(241, 245, 255, 0.98) 100%);
  color: hsl(var(--foreground));
}

.audit-chat-panel .chat-header {
  background: rgba(255, 255, 255, 0.72);
  border-color: hsl(var(--border));
}

.audit-chat-panel .chat-composer {
  background: rgba(255, 255, 255, 0.78);
  border-color: hsl(var(--border));
}

.dark .audit-sidebar {
  background:
    radial-gradient(circle at top left, rgba(59, 130, 246, 0.16), transparent 24%),
    linear-gradient(180deg, #171a22 0%, #11131a 48%, #0f1117 100%);
}

.dark .audit-sidebar .text-muted-foreground {
  color: #cbd5e1 !important;
}

.dark .audit-sidebar .label-xs {
  color: #dbeafe !important;
}

.dark .audit-sidebar .sidebar-nav-item {
  color: #cbd5e1;
}

.dark .audit-sidebar .sidebar-nav-item:hover {
  background: rgba(99, 102, 241, 0.16);
  color: #f8fafc;
}

.dark .audit-sidebar .sidebar-nav-item.active {
  color: #ffffff;
  background: rgba(99, 102, 241, 0.18);
}

.dark .sidebar-stepper::before {
  background: linear-gradient(180deg, rgba(139, 92, 246, 0.12), rgba(139, 92, 246, 0.3), rgba(139, 92, 246, 0.12));
}

.dark .sidebar-journey-progress {
  background: linear-gradient(90deg, #6366f1 0%, #8b5cf6 52%, #a855f7 100%);
  box-shadow: 0 0 18px rgba(139, 92, 246, 0.38);
}

.dark .audit-panel {
  background: linear-gradient(180deg, rgba(255, 255, 255, 0.04), rgba(255, 255, 255, 0.01));
}

.dark .audit-active-audit {
  background: rgba(15, 23, 42, 0.72);
  border-color: rgba(129, 140, 248, 0.28);
  color: #e2e8f0 !important;
}

.dark .audit-active-audit .text-foreground {
  color: #ffffff !important;
}

.dark .audit-active-audit .text-muted-foreground {
  color: #cbd5e1 !important;
}

.dark .audit-chat {
  border-left-color: rgba(148, 163, 184, 0.18);
  background: linear-gradient(180deg, #111827 0%, #0f172a 100%);
}

.dark .audit-chat-panel {
  background: linear-gradient(180deg, #1c1f29 0%, #12151c 100%);
  color: #fff7ed;
}

.dark .audit-chat-panel .chat-header {
  background: rgba(15, 23, 42, 0.86);
  border-color: rgba(148, 163, 184, 0.2);
}

.dark .audit-chat-panel .chat-composer {
  background: rgba(15, 23, 42, 0.92);
  border-color: rgba(148, 163, 184, 0.2);
}

.copilot-shell {
  background:
    radial-gradient(circle at top right, rgba(129, 140, 248, 0.12), transparent 28%),
    linear-gradient(180deg, #111827 0%, #0b1220 100%) !important;
  color: #e5e7eb;
}

.copilot-header {
  padding: 18px 16px;
  background: rgba(15, 23, 42, 0.86) !important;
  border-color: rgba(148, 163, 184, 0.18) !important;
  box-shadow: 0 12px 30px rgba(2, 6, 23, 0.24);
}

.copilot-title {
  color: #a5b4fc;
  text-shadow: 0 0 18px rgba(129, 140, 248, 0.26);
}

.copilot-context {
  color: #94a3b8;
  letter-spacing: 0.18em;
}

.copilot-avatar {
  border: 2px solid rgba(199, 210, 254, 0.86);
  box-shadow: 0 0 24px rgba(129, 140, 248, 0.24);
}

.copilot-icon-btn {
  color: #a5b4fc !important;
  background: rgba(15, 23, 42, 0.44) !important;
  border: 1px solid rgba(129, 140, 248, 0.14);
}

.copilot-icon-btn:hover {
  background: rgba(129, 140, 248, 0.16) !important;
  color: #ddd6fe !important;
}

.copilot-scroll {
  background:
    linear-gradient(90deg, rgba(30, 41, 59, 0.08) 1px, transparent 1px),
    linear-gradient(180deg, rgba(30, 41, 59, 0.08) 1px, transparent 1px);
  background-size: 44px 44px;
}

.copilot-day-divider {
  display: flex;
  align-items: center;
  gap: 12px;
  color: #94a3b8;
  font-size: 12px;
  font-weight: 700;
}

.copilot-day-divider::before,
.copilot-day-divider::after {
  content: "";
  height: 1px;
  flex: 1 1;
  background: rgba(148, 163, 184, 0.14);
}

.copilot-day-divider {
  animation: phaseSectionIn 420ms cubic-bezier(0.2, 0.9, 0.2, 1) both;
}

.copilot-context-card {
  background: rgba(15, 23, 42, 0.54) !important;
  border-color: rgba(99, 102, 241, 0.24) !important;
  border-radius: 16px;
}

.copilot-welcome {
  background: linear-gradient(135deg, rgba(20, 184, 166, 0.18), rgba(99, 102, 241, 0.12)) !important;
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.04);
}

.copilot-welcome .bg-primary {
  background: linear-gradient(135deg, #6366f1, #8b5cf6) !important;
}

.copilot-welcome .bg-primary:hover {
  background: linear-gradient(135deg, #818cf8, #a78bfa) !important;
}

.copilot-bot-mark {
  background: linear-gradient(135deg, #6366f1, #8b5cf6);
  color: #eef2ff;
  box-shadow: 0 12px 26px rgba(79, 70, 229, 0.28);
  position: relative;
  overflow: hidden;
}

.copilot-user-mark {
  background: rgba(20, 184, 166, 0.14);
  color: #99f6e4;
  border: 1px solid rgba(45, 212, 191, 0.18);
}

.copilot-message-row {
  animation: messageSlideIn 520ms cubic-bezier(0.2, 0.9, 0.2, 1) both;
  animation-delay: var(--message-delay, 0ms);
}

.message-user-row {
  transform-origin: right center;
}

.message-assistant-row {
  transform-origin: left center;
}

.copilot-message {
  border-radius: 20px;
  box-shadow: 0 16px 34px rgba(2, 6, 23, 0.2);
  position: relative;
  overflow: hidden;
}

.copilot-user-message {
  border-top-right-radius: 6px;
  background: linear-gradient(135deg, #6366f1, #8b5cf6 58%, #22d3ee);
  box-shadow: 0 16px 34px rgba(79, 70, 229, 0.26);
}

.copilot-user-message::after {
  content: "";
  position: absolute;
  inset: 0;
  background: linear-gradient(110deg, transparent 0%, rgba(255, 255, 255, 0.22) 26%, transparent 48%);
  transform: translateX(-120%);
  animation: messageShimmer 4.2s ease-in-out infinite;
}

.copilot-assistant-message {
  border-top-left-radius: 6px;
  background:
    linear-gradient(180deg, rgba(20, 27, 43, 0.96), rgba(15, 23, 42, 0.96)) !important;
  border-color: rgba(129, 140, 248, 0.18) !important;
}

.copilot-assistant-message::before {
  content: "";
  position: absolute;
  inset: auto -20% 0 -20%;
  height: 1px;
  background: linear-gradient(90deg, transparent 0%, rgba(45, 212, 191, 0.42) 50%, transparent 100%);
}

.copilot-message-text {
  color: #e5e7eb;
}

.copilot-message-text strong {
  color: #2dd4bf;
  font-weight: 800;
}

.copilot-evidence-card {
  background: rgba(2, 6, 23, 0.22);
  border-radius: 12px;
  padding: 8px;
}

.copilot-composer {
  background: rgba(15, 23, 42, 0.92) !important;
  border-color: rgba(148, 163, 184, 0.18) !important;
}

.copilot-chip {
  border-color: rgba(129, 140, 248, 0.26) !important;
  background: rgba(15, 23, 42, 0.64) !important;
  color: #c7d2fe !important;
}

.copilot-chip:hover {
  background: rgba(99, 102, 241, 0.18) !important;
}

.copilot-input-shell {
  min-height: 56px;
  border: 1px solid rgba(148, 163, 184, 0.18);
  border-radius: 22px;
  background: rgba(15, 23, 42, 0.9);
  padding: 6px;
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.03), 0 18px 36px rgba(2, 6, 23, 0.22);
}

.copilot-input-icon {
  color: #94a3b8 !important;
}

.copilot-input-icon:hover {
  color: #c7d2fe !important;
  background: rgba(129, 140, 248, 0.12) !important;
}

.copilot-send {
  border-radius: 18px !important;
  background: linear-gradient(135deg, #c4b5fd, #6366f1) !important;
  color: #111827 !important;
  box-shadow: 0 12px 28px rgba(99, 102, 241, 0.34);
  position: relative;
  overflow: hidden;
}

.copilot-send:hover {
  background: linear-gradient(135deg, #ddd6fe, #818cf8) !important;
  transform: translateY(-1px);
}

.copilot-send-armed {
  animation: sendPulse 1.6s ease-in-out infinite;
}

.copilot-send-armed::after {
  content: "";
  position: absolute;
  inset: 0;
  background: linear-gradient(110deg, transparent 0%, rgba(255, 255, 255, 0.36) 40%, transparent 70%);
  transform: translateX(-125%);
  animation: messageShimmer 2.8s ease-in-out infinite;
}

.copilot-thinking-row {
  animation: phaseSectionIn 320ms ease both;
}

.copilot-thinking-mark {
  box-shadow: 0 0 0 8px rgba(99, 102, 241, 0.08), 0 0 24px rgba(45, 212, 191, 0.22);
}

.copilot-thinking-bubble {
  border-color: rgba(129, 140, 248, 0.24);
  background:
    radial-gradient(circle at top right, rgba(45, 212, 191, 0.12), transparent 35%),
    linear-gradient(180deg, rgba(20, 27, 43, 0.96), rgba(15, 23, 42, 0.96));
  box-shadow: 0 12px 28px rgba(2, 6, 23, 0.2);
}

.copilot-typing-dots {
  display: inline-flex;
  gap: 4px;
  align-items: center;
}

.copilot-typing-dots span {
  width: 5px;
  height: 5px;
  border-radius: 999px;
  background: linear-gradient(135deg, #2dd4bf, #a5b4fc);
  animation: typingBounce 0.95s ease-in-out infinite;
}

.copilot-typing-dots span:nth-child(2) {
  animation-delay: 0.12s;
}

.copilot-typing-dots span:nth-child(3) {
  animation-delay: 0.24s;
}

.dark .assistant-overlay {
  border-color: rgba(96, 165, 250, 0.24);
  background: linear-gradient(135deg, rgba(29, 78, 216, 0.34), rgba(27, 31, 40, 0.95));
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.04);
}

.dark .assistant-overlay-card {
  background: linear-gradient(145deg, rgba(28, 30, 39, 0.96), rgba(20, 22, 30, 0.98));
  box-shadow: 0 12px 24px rgba(0, 0, 0, 0.24);
}

.dark .assistant-task-track {
  background: rgba(59, 130, 246, 0.18);
}

.dark .quick-actions-item {
  border-color: rgba(96, 165, 250, 0.2);
  background: rgba(26, 28, 36, 0.88);
  box-shadow: 0 10px 24px rgba(0, 0, 0, 0.2);
}

.dark .quick-actions-track {
  background: rgba(71, 85, 105, 0.45);
}

.dark .executive-glass {
  background: linear-gradient(140deg, rgba(33, 36, 46, 0.94), rgba(20, 23, 31, 0.88)) !important;
  border-color: rgba(96, 165, 250, 0.18) !important;
  box-shadow: 0 14px 32px rgba(0, 0, 0, 0.28), inset 0 1px 0 rgba(255, 255, 255, 0.03);
}

.dark .executive-hero {
  background: linear-gradient(120deg, #1d4ed8 0%, #2563eb 40%, #0b1220 100%) !important;
  box-shadow: 0 16px 30px rgba(0, 0, 0, 0.24);
}

.dark .phase10-command-brief,
.phase10-command-brief {
  background:
    radial-gradient(circle at top right, rgba(34, 211, 238, 0.13), transparent 30%),
    linear-gradient(120deg, #172554 0%, #312e81 45%, #0b1220 100%) !important;
  border: 1px solid rgba(129, 140, 248, 0.24) !important;
  box-shadow: 0 18px 42px rgba(2, 6, 23, 0.24);
}

.dark .hero-progress-wrap {
  background: rgba(17, 24, 39, 0.34);
  border-color: rgba(255, 234, 214, 0.12);
}

.dark .hero-progress-track {
  background: rgba(255, 245, 235, 0.1);
}

.dark .hero-progress-fill {
  background: linear-gradient(90deg, #bfdbfe, #e0f2fe);
}

.dark .phase10-readable,
.dark .phase10-readable * {
  color: hsl(var(--foreground));
}

.dark .phase10-readable .phase10-print-preview,
.dark .phase10-readable .phase10-print-preview * {
  color: #111827 !important;
}

.dark .phase10-readable .phase10-print-preview .text-muted-foreground,
.dark .phase10-readable .phase10-print-preview [style*="color: #6b7280"],
.dark .phase10-readable .phase10-print-preview [style*="color:#6b7280"],
.dark .phase10-readable .phase10-print-preview [style*="color: #9ca3af"],
.dark .phase10-readable .phase10-print-preview [style*="color:#9ca3af"] {
  color: #4b5563 !important;
}

.dark .phase10-readable .phase10-print-preview [style*="color: #374151"],
.dark .phase10-readable .phase10-print-preview [style*="color:#374151"] {
  color: #374151 !important;
}

.dark .phase10-readable .phase10-print-preview h3,
.dark .phase10-readable .phase10-print-preview table,
.dark .phase10-readable .phase10-print-preview table td,
.dark .phase10-readable .phase10-print-preview table th,
.dark .phase10-readable .phase10-print-preview p,
.dark .phase10-readable .phase10-print-preview span,
.dark .phase10-readable .phase10-print-preview li {
  color: #111827 !important;
}

.dark .phase10-readable .phase10-print-preview table th,
.dark .phase10-readable .phase10-print-preview p[style*="color: #6b7280"],
.dark .phase10-readable .phase10-print-preview span[style*="color: #6b7280"],
.dark .phase10-readable .phase10-print-preview td[style*="color: #6b7280"],
.dark .phase10-readable .phase10-print-preview [style*="color:#6b7280"] {
  color: #4b5563 !important;
}

.dark .phase10-readable .phase10-print-preview .phase10-finding-card,
.dark .phase10-readable .phase10-print-preview .phase10-finding-card * {
  color: #f8fafc !important;
}

.dark .phase10-readable .text-muted-foreground {
  color: #cbd5e1 !important;
}

.dark .phase10-readable .recharts-cartesian-axis-tick-value,
.dark .phase10-readable .recharts-polar-angle-axis text,
.dark .phase10-readable .recharts-polar-radius-axis text,
.dark .phase10-readable .recharts-tooltip-wrapper {
  fill: #cbd5e1;
  color: #cbd5e1;
}

.dark [data-testid="header"] {
  background: rgba(12, 18, 32, 0.94);
  border-bottom-color: rgba(255, 255, 255, 0.08);
  box-shadow: 0 10px 35px rgba(0, 0, 0, 0.18);
}

.dark [data-testid="header"] .header-kicker,
.dark [data-testid="header"] .header-search-results,
.dark [data-testid="header"] .header-date-pill,
.dark [data-testid="header"] .header-icon-btn {
  background: rgba(15, 23, 42, 0.78);
  border-color: rgba(129, 140, 248, 0.28);
  color: #e2e8f0;
}

.dark [data-testid="header"] .header-popover {
  background: #0f172a;
  border-color: rgba(129, 140, 248, 0.38);
  color: #f8fafc;
  box-shadow: 0 24px 60px rgba(0, 0, 0, 0.55);
}

.dark [data-testid="header"] .header-popover > div:first-child {
  background: #111c33;
  border-bottom-color: rgba(129, 140, 248, 0.26);
}

.dark [data-testid="header"] .header-title {
  color: #f8fafc;
}

.dark [data-testid="header"] .header-subtitle,
.dark [data-testid="header"] .header-empty,
.dark [data-testid="header"] .header-item-sub {
  color: #cbd5e1;
}

.dark [data-testid="header"] .header-item:hover {
  background: rgba(99, 102, 241, 0.18);
}

.dark [data-testid="header"] .header-item-title,
.dark [data-testid="header"] .header-popover-title,
.dark [data-testid="header"] .header-date-pill {
  color: #f8fafc;
}

.dark [data-testid="header"] .header-item {
  color: #f1f5f9;
}

.header-kicker,
.header-date-pill,
.header-icon-btn,
.header-search-results,
.header-popover {
  animation: phaseSectionIn 420ms cubic-bezier(0.2, 0.9, 0.2, 1) both;
}

.header-kicker { animation-delay: 60ms; }
.header-search-results { animation-delay: 120ms; }
.header-date-pill { animation-delay: 180ms; }
.header-icon-btn { animation-delay: 220ms; }
.header-popover { animation-delay: 80ms; }

.dark [data-testid="login-page"] .login-shell {
  background: rgba(17, 20, 29, 0.78);
  border-color: rgba(59, 130, 246, 0.12);
  box-shadow: 0 28px 80px rgba(0, 0, 0, 0.28);
}

.dark [data-testid="login-page"] .login-panel {
  background: rgba(20, 24, 33, 0.92);
}

.dark [data-testid="login-page"] .login-title {
  color: #f8fafc;
}

.dark [data-testid="login-page"] .login-copy {
  color: #94a3b8;
}

.dark [data-testid="login-page"] .login-card {
  background: rgba(23, 27, 37, 0.92);
  border-color: rgba(255, 255, 255, 0.08);
}

.ai-sparkle {
  animation: sparkleSpin 2.6s linear infinite;
}

.heatmap-threshold-bg {
  background:
    linear-gradient(135deg, rgba(34, 197, 94, 0.12) 0%, rgba(59, 130, 246, 0.14) 48%, rgba(239, 68, 68, 0.12) 100%),
    linear-gradient(180deg, rgba(255, 255, 255, 0.6), rgba(224, 242, 254, 0.35));
  border: 1px solid rgba(147, 197, 253, 0.45);
}

.quick-actions-panel {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.quick-actions-item {
  width: 100%;
  text-align: left;
  border: 1px solid rgba(235, 194, 160, 0.5);
  background: rgba(255, 252, 248, 0.88);
  border-radius: 14px;
  padding: 8px;
  animation: rowIn 420ms ease both;
  animation-delay: var(--qa-delay, 0ms);
  transition: transform 170ms ease, box-shadow 170ms ease;
}

.quick-actions-item:hover {
  transform: translateX(4px);
  box-shadow: 0 8px 18px rgba(15, 23, 42, 0.1);
}

.quick-actions-track {
  height: 6px;
  border-radius: 999px;
  margin-top: 6px;
  background: #e2e8f0;
  overflow: hidden;
}

.quick-actions-fill {
  height: 100%;
  border-radius: 999px;
  background: linear-gradient(90deg, #2563eb, #60a5fa);
  animation: progressGrow 900ms cubic-bezier(0.2, 0.8, 0.2, 1) both;
}

.agent-scanning {
  letter-spacing: 0.02em;
}

.assistant-overlay {
  border: 1px solid rgba(37, 99, 235, 0.22);
  border-radius: 16px;
  background: linear-gradient(135deg, rgba(238, 242, 255, 0.97), rgba(224, 242, 254, 0.96));
  padding: 10px;
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.8);
}

.assistant-task-row {
  animation: rowIn 420ms ease both;
  animation-delay: var(--task-delay, 0ms);
}

.assistant-task-track {
  height: 5px;
  border-radius: 999px;
  background: #bfdbfe;
  overflow: hidden;
  margin-top: 4px;
}

.assistant-task-fill {
  height: 100%;
  border-radius: 999px;
  background: linear-gradient(90deg, #2563eb, #60a5fa);
  animation: progressGrow 800ms cubic-bezier(0.2, 0.8, 0.2, 1) both;
}

.assistant-overlay-card {
  background: linear-gradient(145deg, rgba(236, 253, 245, 0.95), rgba(239, 246, 255, 0.98));
  box-shadow: 0 8px 18px rgba(15, 23, 42, 0.08);
}

.typing-dots::after {
  content: "...";
  display: inline-block;
  width: 12px;
  overflow: hidden;
  vertical-align: bottom;
  animation: typingDots 1.1s steps(4, end) infinite;
}

/* Keyframes */
@keyframes orbFloat {
  from { transform: translateY(-8px) scale(1); }
  to { transform: translateY(10px) scale(1.05); }
}

@keyframes particlesDrift {
  from { transform: translateY(0); }
  to { transform: translateY(-20px); }
}

@keyframes navItemIn {
  from { opacity: 0; transform: translateX(-10px); }
  to { opacity: 1; transform: translateX(0); }
}

@keyframes sidebarIn {
  from { opacity: 0; transform: translateX(-16px); }
  to { opacity: 1; transform: translateX(0); }
}

@keyframes metricIn {
  from { opacity: 0; transform: translateY(18px) scale(0.98); }
  to { opacity: 1; transform: translateY(0) scale(1); }
}

@keyframes rowIn {
  from { opacity: 0; transform: translateY(8px); }
  to { opacity: 1; transform: translateY(0); }
}

@keyframes progressGrow {
  from { transform: scaleX(0); }
  to { transform: scaleX(1); }
}

@keyframes phasePageIn {
  from { opacity: 0; transform: translateY(18px) scale(0.99); }
  to { opacity: 1; transform: translateY(0) scale(1); }
}

@keyframes phaseSectionIn {
  from { opacity: 0; transform: translateY(14px); }
  to { opacity: 1; transform: translateY(0); }
}

@keyframes phaseDotIn {
  from { opacity: 0; transform: scale(0.82); }
  to { opacity: 1; transform: scale(1); }
}

@keyframes currentPhasePulse {
  0%, 100% {
    box-shadow: 0 0 0 6px rgba(99, 102, 241, 0.12), 0 0 22px rgba(99, 102, 241, 0.26);
  }
  50% {
    box-shadow: 0 0 0 9px rgba(99, 102, 241, 0.08), 0 0 28px rgba(45, 212, 191, 0.24);
  }
}

@keyframes heroGradientDrift {
  from { background-position: 0% 0%, 0% 0%, 0% 0%; }
  to { background-position: 5% 8%, -4% 4%, 100% 100%; }
}

@keyframes messageSlideIn {
  from { opacity: 0; transform: translateY(18px) scale(0.96); }
  to { opacity: 1; transform: translateY(0) scale(1); }
}

@keyframes messageShimmer {
  0% { transform: translateX(-125%); }
  45%, 100% { transform: translateX(125%); }
}

@keyframes typingBounce {
  0%, 80%, 100% { transform: translateY(0); opacity: 0.45; }
  40% { transform: translateY(-4px); opacity: 1; }
}

@keyframes sendPulse {
  0%, 100% { box-shadow: 0 12px 28px rgba(99, 102, 241, 0.34); }
  50% { box-shadow: 0 16px 36px rgba(45, 212, 191, 0.26); }
}

@keyframes scanSweep {
  0% { transform: translateX(-120%); }
  55%, 100% { transform: translateX(120%); }
}

@keyframes bellPulse {
  0%, 100% { opacity: 0.9; transform: scale(1); }
  50% { opacity: 0.45; transform: scale(0.84); }
}

@keyframes floatBtnIn {
  from { opacity: 0; transform: translateY(24px) scale(0.92); }
  to { opacity: 1; transform: translateY(0) scale(1); }
}

@keyframes sparkleSpin {
  from { transform: rotate(0deg); }
  to { transform: rotate(360deg); }
}

@keyframes typingDots {
  0% { width: 0; }
  100% { width: 12px; }
}

@keyframes healthPulse {
  0% {
    transform: scale(1);
    box-shadow: 0 0 0 0 var(--pulse-color, rgba(148, 163, 184, 0.4));
  }
  70% {
    transform: scale(1.02);
    box-shadow: 0 0 0 7px transparent;
  }
  100% {
    transform: scale(1);
    box-shadow: 0 0 0 0 transparent;
  }
}

@media (prefers-reduced-motion: reduce) {
  .ambient-orb,
  .ambient-particles,
  .sidebar-nav-item,
  .metric-card-anim,
  .table-row-anim,
  .progress-anim,
  .notification-pulse,
  .floating-ai-btn,
  .ai-sparkle,
  .phase-step-dot,
  .phase-step-line::after,
  [data-testid^="phase-"],
  [data-testid^="phase-"] > *,
  .phase7-hero,
  .phase7-console-card,
  .phase7-control-row,
  .phase7-progress-card,
  .header-kicker,
  .header-date-pill,
  .header-icon-btn,
  .header-search-results,
  .header-popover,
  .audit-card,
  .copilot-message-row,
  .copilot-user-message::after,
  .copilot-send-armed,
  .copilot-send-armed::after,
  .copilot-typing-dots span,
  .progress-bar-indicator::after,
  .hero-progress-fill::after,
  .quick-actions-fill::after,
  .assistant-task-fill::after {
    animation: none !important;
    transition: none !important;
  }
}

@media (max-width: 1280px) {
  .audit-layout {
    grid-template-columns: 13rem 1fr 18.5rem;
  }
}

@media (max-width: 1100px) {
  .audit-layout,
  .audit-layout.chat-closed {
    grid-template-columns: 12rem 1fr;
  }

  .audit-chat {
    display: none;
  }

  .audit-sidebar .sidebar-nav-item {
    padding-left: 1rem;
  }

  .audit-sidebar .sidebar-stepper::before {
    display: none;
  }
}

@media (max-width: 860px) {
  .audit-layout,
  .audit-layout.chat-closed {
    grid-template-columns: 1fr;
    grid-template-rows: auto auto 1fr;
    height: auto;
    min-height: 100vh;
    overflow: auto;
  }

  .audit-sidebar {
    grid-row: 1;
    grid-column: 1;
  }

  .audit-header {
    grid-row: 2;
    grid-column: 1;
  }

  .audit-main {
    grid-row: 3;
    grid-column: 1;
    min-height: 0;
  }

  .audit-sidebar {
    height: auto;
  }

  .audit-brand {
    padding-top: 0.9rem;
    padding-bottom: 0.9rem;
  }

  .audit-panel {
    padding: 0.75rem;
  }

  .floating-ai-btn {
    right: 0.8rem;
    bottom: 0.8rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA,mBAAmB;AACnB;EACE,aAAa;EACb,wCAAwC;EACxC,4BAA4B;EAC5B,aAAa;EACb,gBAAgB;EAChB;;;qDAGmD;EACnD,qDAAqD;AACvD;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,8DAA8D;AAChE;;AAEA;EACE;;wHAEsH;AACxH;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,WAAW;EACX,6DAA6D;EAC7D,aAAa;AACf;;AAEA;EACE,yFAAyF;AAC3F;;AAEA;EACE,qCAAqC;EACrC,2CAA2C;EAC3C,mBAAmB;EACnB,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,UAAU;EACV,WAAW;EACX,oBAAoB;EACpB,qBAAqB;EACrB,gDAAgD;AAClD;;AAEA;EACE,mBAAmB;EACnB,sCAAsC;AACxC;;AAEA;EACE,mBAAmB;EACnB,uCAAuC;AACzC;;AAEA;EACE,mBAAmB;EACnB,sCAAsC;AACxC;;AAEA;EACE,UAAU;EACV,WAAW;EACX,oBAAoB;EACpB,mBAAmB;EACnB,4CAA4C;AAC9C;;AAEA;EACE,cAAc;EACd,6BAA6B;EAC7B,qCAAqC;AACvC;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,mCAAmC;EACnC,qCAAqC;EACrC,cAAc;EACd,mDAAmD;AACrD;;AAEA;EACE,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB;;;qDAGmD;EACnD;;;0BAGwB;AAC1B;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,iBAAiB;EACjB,aAAa;EACb;;kEAEgE;EAChE,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,mBAAmB;EACnB;;;0BAGwB;AAC1B;;AAEA;EACE;;kEAEgE;AAClE;;AAEA;;;EAGE,6CAA6C;AAC/C;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,4BAA4B;EAC5B,yCAAyC;EACzC,iGAAiG;AACnG;;AAEA,mBAAmB;AACnB;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAO;AACT;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,UAAU;EACV,0BAA0B;EAC1B,+DAA+D;EAC/D,wCAAwC;AAC1C;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,SAAS;EACT,WAAW;EACX,WAAW;EACX,UAAU;EACV,8BAA8B;EAC9B,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,6BAA6B;EAC7B,oBAAoB;EACpB,4EAA4E;AAC9E;;AAEA;EACE,iEAAiE;EACjE,sDAAsD;AACxD;;AAEA;EACE,uCAAuC;EACvC,8CAA8C;AAChD;;AAEA;EACE,iFAAiF;EACjF;;+CAE6C;EAC7C,+EAA+E;AACjF;;AAEA;EACE,6CAA6C;AAC/C;;AAEA;EACE,gCAAgC;EAChC,sDAAsD;AACxD;;AAEA,WAAW;AACX;EACE,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA,uBAAuB;AACvB;;EAEE,uBAAuB;EACvB,oBAAoB;AACtB;;AAEA;EACE,oBAAoB;EACpB,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA,oBAAoB;AACH;EAAA,sBAAqG;EAArG,4DAAqG;EAArG,kBAAqG;EAArG,4DAAqG;EAArG,oBAAqG;EAArG;AAAqG;AAArG;EAAA,sBAAqG;EAArG,0DAAqG;EAArG,qCAAqG;EAArG,oBAAqG;EAArG;AAAqG;AACnG;EAAA,sBAAiH;EAAjH,4DAAiH;EAAjH,kBAAiH;EAAjH,4DAAiH;EAAjH,oBAAiH;EAAjH;AAAiH;AAAjH;EAAA,sBAAiH;EAAjH,0DAAiH;EAAjH,oCAAiH;EAAjH,oBAAiH;EAAjH;AAAiH;AACpH;EAAA,sBAA2G;EAA3G,4DAA2G;EAA3G,kBAA2G;EAA3G,4DAA2G;EAA3G,oBAA2G;EAA3G;AAA2G;AAA3G;EAAA,sBAA2G;EAA3G,0DAA2G;EAA3G,qCAA2G;EAA3G,oBAA2G;EAA3G;AAA2G;AACnG;EAAA,sBAAiH;EAAjH,4DAAiH;EAAjH,kBAAiH;EAAjH,4DAAiH;EAAjH,oBAAiH;EAAjH;AAAiH;AAAjH;EAAA,sBAAiH;EAAjH,yDAAiH;EAAjH,mCAAiH;EAAjH,oBAAiH;EAAjH;AAAiH;;AAEzI,sBAAsB;AACtB;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,qBAAqB;AACvB;;AAEgB;EAAA,kBAAqB;EAArB;AAAqB;AACjB;EAAA;IAAA;EAAiC;AAAA;AAAjC;EAAA,yDAAiC;EAAjC,kBAAiC;EAAjC;AAAiC;AACnC;EAAA;IAAA;EAAgC;AAAA;AAAhC;EAAA,yDAAgC;EAAhC,kBAAgC;EAAhC;AAAgC;AAC7B;EAAA;IAAA;EAAkC;AAAA;AAAlC;EAAA,yDAAkC;EAAlC,kBAAkC;EAAlC;AAAkC;AACpC;EAAA,kBAAmB;EAAnB;AAAmB;;AAEtC,2BAA2B;AAC3B;EACE,OAAO,UAAU,EAAE,0BAA0B,EAAE;EAC/C,KAAK,UAAU,EAAE,wBAAwB,EAAE;AAC7C;;AAEA;EACE,kCAAkC;AACpC;;AAEA,yBAAyB;AACzB;EACE,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;;EAEE,cAAc;AAChB;;AAEA,yDAAyD;AACzD;;;EAGE,oCAAoC;AACtC;;AAEA;EACE,uCAAuC;AACzC;;AAEA,sEAAsE;AACtE;EACE,yBAAyB;EACzB,0CAA0C;AAC5C;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,gEAAgE;AAClE;;AAEA;EACE,mEAAmE;AACrE;;AAEA,uDAAuD,qBAAqB,EAAE;AAC9E,uDAAuD,sBAAsB,EAAE;AAC/E,uDAAuD,sBAAsB,EAAE;AAC/E,uDAAuD,sBAAsB,EAAE;AAC/E,uDAAuD,sBAAsB,EAAE;;AAE/E,qCAAqC;AACrC;EACE,kBAAkB;EAClB,kBAAkB;EAClB,uCAAuC;EACvC;;;kFAGgF;EAChF,qFAAqF;EACrF,+DAA+D;AACjE;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX;;0EAEwE;EACxE,0BAA0B;EAC1B,2DAA2D;AAC7D;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,2BAA2B;EAC3B,gFAAgF;AAClF;;AAEA;EACE,2BAA2B;EAC3B,sCAAsC;EACtC,qCAAqC;AACvC;;AAEA;;;EAGE,mEAAmE;AACrE;;AAEA;EACE,gBAAgB;EAChB,4CAA4C;AAC9C;;AAEA;EACE;sFACoF;EACpF,kDAAkD;EAClD,oFAAoF;AACtF;;AAEA;;EAEE,2CAA2C;EAC3C,kDAAkD;AACpD;;AAEA;EACE,6CAA6C;EAC7C,kDAAkD;AACpD;;AAEA;EACE,iDAAiD;AACnD;;AAEA,qDAAqD;AACrD;;EAEE,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;;EAGE,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,2CAA2C;EAC3C,mBAAmB;EACnB;;kEAEgE;EAChE,4CAA4C;AAC9C;;AAEA;EACE,8CAA8C;EAC9C,6BAA6B;EAC7B,4BAA4B;AAC9B;;AAEA;;;EAGE,mDAAmD;AACrD;;AAEA;;EAEE,kDAAkD;EAClD,cAAc;AAChB;;AAEA;;EAEE,sDAAsD;AACxD;;AAEA;EACE,8BAA8B;EAC9B,qCAAqC;EACrC,oCAAoC;AACtC;;AAEA;EACE,eAAe;EACf,oBAAoB;EACpB,UAAU;EACV,kBAAkB;EAClB,YAAY;EACZ,qBAAqB;EACrB,sDAAsD;AACxD;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,UAAU;EACV,QAAQ;EACR,mFAAmF;AACrF;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,UAAU;EACV,UAAU;EACV,qFAAqF;EACrF,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,QAAQ;EACR,oBAAoB;EACpB,UAAU;EACV;;;qFAGmF;EACnF,sDAAsD;EACtD,6CAA6C;EAC7C,aAAa;AACf;;AAEA,+BAA+B;AAC/B;EACE,wBAAwB;EACxB,0DAA0D;AAC5D;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,8DAA8D;EAC9D,oCAAoC;EACpC,uDAAuD;AACzD;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,kDAAkD;AACpD;;AAEA;EACE,sBAAsB;EACtB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,OAAO;EACP,QAAQ;EACR,WAAW;EACX,UAAU;EACV,oBAAoB;EACpB,mBAAmB;EACnB,4CAA4C;AAC9C;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,SAAS;EACT,YAAY;EACZ,UAAU;EACV,kHAAkH;AACpH;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,yEAAyE;EACzE,6CAA6C;EAC7C,4BAA4B;AAC9B;;AAEA;EACE,WAAW;EACX,UAAU;EACV,oBAAoB;EACpB,mBAAmB;EACnB,6CAA6C;AAC/C;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,iFAAiF;AACnF;;AAEA;EACE,iFAAiF;AACnF;;AAEA,mCAAmC;AACnC;EACE,kDAAkD;AACpD;;AAEA;EACE,0BAA0B;AAC5B;;AAEA,sCAAsC;AACtC;EACE,kBAAkB;EAClB,gBAAgB;EAChB,gEAAgE;EAChE,kCAAkC;EAClC,uDAAuD;AACzD;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,OAAO;EACP,QAAQ;EACR,SAAS;EACT,WAAW;EACX,8FAA8F;EAC9F,UAAU;EACV,0BAA0B;EAC1B,oDAAoD;AACtD;;AAEA;EACE,2BAA2B;EAC3B,6CAA6C;AAC/C;;AAEA;EACE,UAAU;EACV,wBAAwB;AAC1B;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,mGAAmG;EACnG,UAAU;EACV,2BAA2B;EAC3B,oDAAoD;EACpD,oBAAoB;AACtB;;AAEA;EACE,UAAU;EACV,0BAA0B;AAC5B;;AAEA;EACE,qFAAqF;AACvF;;AAEA;EACE,oGAAoG;EACpG,oDAAoD;EACpD,wFAAwF;EACxF,2BAA2B;AAC7B;;AAEA;EACE,8FAA8F;EAC9F,iDAAiD;EACjD,oFAAoF;AACtF;;AAEA;EACE,qFAAqF;EACrF,+CAA+C;AACjD;;AAEA;EACE,gBAAgB;EAChB,qCAAqC;EACrC,2CAA2C;EAC3C,mBAAmB;EACnB,aAAa;EACb,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,eAAe;EACf,gCAAgC;EAChC,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,oBAAoB;EACpB,eAAe;EACf,qCAAqC;EACrC,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,oBAAoB;EACpB,oDAAoD;EACpD,iEAAiE;EACjE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;;;EAGE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,kGAAkG;EAClG,4BAA4B;EAC5B,8CAA8C;AAChD;;AAEA,gCAAgC;AAChC;EACE,gCAAgC;EAChC,sCAAsC;AACxC;;AAEA;EACE,gCAAgC;AAClC;;AAEA,0CAA0C,qBAAqB,EAAE;AACjE,0CAA0C,qBAAqB,EAAE;AACjE,0CAA0C,sBAAsB,EAAE;AAClE,0CAA0C,sBAAsB,EAAE;AAClE,0CAA0C,sBAAsB,EAAE;;AAElE;EACE,6BAA6B;EAC7B,iEAAiE;EACjE,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,mGAAmG;EACnG,4BAA4B;EAC5B,8CAA8C;AAChD;;AAEA,uBAAuB;AACvB;EACE,8CAA8C;AAChD;;AAEA,uBAAuB;AACvB;EACE,eAAe;EACf,aAAa;EACb,cAAc;EACd,WAAW;EACX,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,oBAAoB;EACpB,qDAAqD;EACrD,YAAY;EACZ,+CAA+C;EAC/C,kEAAkE;AACpE;;AAEA;EACE,iGAAiG;EACjG,6BAA6B;AAC/B;;AAEA;EACE,qCAAqC;EACrC,gCAAgC;AAClC;;AAEA;EACE,qCAAqC;EACrC,gCAAgC;AAClC;;AAEA;EACE;;kEAEgE;AAClE;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,oCAAoC;EACpC,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,oCAAoC;AACtC;;AAEA;EACE,gHAAgH;AAClH;;AAEA;EACE,yEAAyE;EACzE,6CAA6C;AAC/C;;AAEA;EACE,yFAAyF;AAC3F;;AAEA;EACE,kCAAkC;EAClC,uCAAuC;EACvC,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,4CAA4C;EAC5C,6DAA6D;AAC/D;;AAEA;EACE,6DAA6D;EAC7D,cAAc;AAChB;;AAEA;EACE,kCAAkC;EAClC,sCAAsC;AACxC;;AAEA;EACE,kCAAkC;EAClC,sCAAsC;AACxC;;AAEA;EACE;;gEAE8D;EAC9D,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,6CAA6C;EAC7C,kDAAkD;EAClD,4CAA4C;AAC9C;;AAEA;EACE,cAAc;EACd,+CAA+C;AACjD;;AAEA;EACE,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,2CAA2C;EAC3C,8CAA8C;AAChD;;AAEA;EACE,yBAAyB;EACzB,6CAA6C;EAC7C,2CAA2C;AAC7C;;AAEA;EACE,gDAAgD;EAChD,yBAAyB;AAC3B;;AAEA;EACE;;wEAEsE;EACtE,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;;EAEE,WAAW;EACX,WAAW;EACX,SAAO;EACP,qCAAqC;AACvC;;AAEA;EACE,mEAAmE;AACrE;;AAEA;EACE,6CAA6C;EAC7C,iDAAiD;EACjD,mBAAmB;AACrB;;AAEA;EACE,kGAAkG;EAClG,mDAAmD;AACrD;;AAEA;EACE,gEAAgE;AAClE;;AAEA;EACE,gEAAgE;AAClE;;AAEA;EACE,qDAAqD;EACrD,cAAc;EACd,+CAA+C;EAC/C,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,oCAAoC;EACpC,cAAc;EACd,0CAA0C;AAC5C;;AAEA;EACE,mEAAmE;EACnE,0CAA0C;AAC5C;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,mBAAmB;EACnB,2CAA2C;EAC3C,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,4BAA4B;EAC5B,kEAAkE;EAClE,+CAA+C;AACjD;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,mGAAmG;EACnG,4BAA4B;EAC5B,mDAAmD;AACrD;;AAEA;EACE,2BAA2B;EAC3B;sFACoF;EACpF,kDAAkD;AACpD;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,uBAAuB;EACvB,WAAW;EACX,kGAAkG;AACpG;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,gCAAgC;EAChC,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,6CAA6C;EAC7C,kDAAkD;AACpD;;AAEA;EACE,kDAAkD;EAClD,6CAA6C;EAC7C,yBAAyB;AAC3B;;AAEA;EACE,+CAA+C;AACjD;;AAEA;EACE,gBAAgB;EAChB,2CAA2C;EAC3C,mBAAmB;EACnB,iCAAiC;EACjC,YAAY;EACZ,qFAAqF;AACvF;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,gDAAgD;AAClD;;AAEA;EACE,8BAA8B;EAC9B,gEAAgE;EAChE,yBAAyB;EACzB,gDAAgD;EAChD,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,gEAAgE;EAChE,2BAA2B;AAC7B;;AAEA;EACE,8CAA8C;AAChD;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,mGAAmG;EACnG,4BAA4B;EAC5B,mDAAmD;AACrD;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,iFAAiF;AACnF;;AAEA;EACE,uCAAuC;EACvC;;2EAEyE;EACzE,2CAA2C;AAC7C;;AAEA;EACE,oBAAoB;EACpB,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,oBAAoB;EACpB,qDAAqD;EACrD,kDAAkD;AACpD;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,sCAAsC;EACtC,oFAAoF;EACpF,mDAAmD;AACrD;;AAEA;EACE,mFAAmF;EACnF,2CAA2C;AAC7C;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,qCAAqC;EACrC,kCAAkC;EAClC,0CAA0C;AAC5C;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,8FAA8F;EAC9F,iDAAiD;EACjD,oFAAoF;AACtF;;AAEA;EACE,qFAAqF;EACrF,2CAA2C;AAC7C;;AAEA;;EAEE;;6EAE2E;EAC3E,sDAAsD;EACtD,4CAA4C;AAC9C;;AAEA;EACE,kCAAkC;EAClC,uCAAuC;AACzC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,oDAAoD;AACtD;;AAEA;;EAEE,6BAA6B;AAC/B;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;;;;;EAKE,yBAAyB;AAC3B;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;;;;;;;EAOE,yBAAyB;AAC3B;;AAEA;;;;;EAKE,yBAAyB;AAC3B;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;;;EAIE,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,kCAAkC;EAClC,8CAA8C;EAC9C,2CAA2C;AAC7C;;AAEA;;;;EAIE,kCAAkC;EAClC,uCAAuC;EACvC,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,uCAAuC;EACvC,cAAc;EACd,2CAA2C;AAC7C;;AAEA;EACE,mBAAmB;EACnB,8CAA8C;AAChD;;AAEA;EACE,cAAc;AAChB;;AAEA;;;EAGE,cAAc;AAChB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;;;EAGE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;;;;;EAKE,mEAAmE;AACrE;;AAEA,iBAAiB,qBAAqB,EAAE;AACxC,yBAAyB,sBAAsB,EAAE;AACjD,oBAAoB,sBAAsB,EAAE;AAC5C,mBAAmB,sBAAsB,EAAE;AAC3C,kBAAkB,qBAAqB,EAAE;;AAEzC;EACE,kCAAkC;EAClC,sCAAsC;EACtC,2CAA2C;AAC7C;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kCAAkC;EAClC,uCAAuC;AACzC;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;EACE;;gFAE8E;EAC9E,2CAA2C;AAC7C;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,0CAA0C;EAC1C,qCAAqC;EACrC,mBAAmB;EACnB,YAAY;EACZ,gCAAgC;EAChC,qCAAqC;EACrC,uDAAuD;AACzD;;AAEA;EACE,0BAA0B;EAC1B,4CAA4C;AAC9C;;AAEA;EACE,WAAW;EACX,oBAAoB;EACpB,eAAe;EACf,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,oBAAoB;EACpB,oDAAoD;EACpD,iEAAiE;AACnE;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,yCAAyC;EACzC,mBAAmB;EACnB,yFAAyF;EACzF,aAAa;EACb,kDAAkD;AACpD;;AAEA;EACE,gCAAgC;EAChC,uCAAuC;AACzC;;AAEA;EACE,WAAW;EACX,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,oBAAoB;EACpB,oDAAoD;EACpD,iEAAiE;AACnE;;AAEA;EACE,yFAAyF;EACzF,6CAA6C;AAC/C;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,WAAW;EACX,gBAAgB;EAChB,sBAAsB;EACtB,iDAAiD;AACnD;;AAEA,cAAc;AACd;EACE,OAAO,oCAAoC,EAAE;EAC7C,KAAK,uCAAuC,EAAE;AAChD;;AAEA;EACE,OAAO,wBAAwB,EAAE;EACjC,KAAK,4BAA4B,EAAE;AACrC;;AAEA;EACE,OAAO,UAAU,EAAE,4BAA4B,EAAE;EACjD,KAAK,UAAU,EAAE,wBAAwB,EAAE;AAC7C;;AAEA;EACE,OAAO,UAAU,EAAE,4BAA4B,EAAE;EACjD,KAAK,UAAU,EAAE,wBAAwB,EAAE;AAC7C;;AAEA;EACE,OAAO,UAAU,EAAE,uCAAuC,EAAE;EAC5D,KAAK,UAAU,EAAE,iCAAiC,EAAE;AACtD;;AAEA;EACE,OAAO,UAAU,EAAE,0BAA0B,EAAE;EAC/C,KAAK,UAAU,EAAE,wBAAwB,EAAE;AAC7C;;AAEA;EACE,OAAO,oBAAoB,EAAE;EAC7B,KAAK,oBAAoB,EAAE;AAC7B;;AAEA;EACE,OAAO,UAAU,EAAE,uCAAuC,EAAE;EAC5D,KAAK,UAAU,EAAE,iCAAiC,EAAE;AACtD;;AAEA;EACE,OAAO,UAAU,EAAE,2BAA2B,EAAE;EAChD,KAAK,UAAU,EAAE,wBAAwB,EAAE;AAC7C;;AAEA;EACE,OAAO,UAAU,EAAE,sBAAsB,EAAE;EAC3C,KAAK,UAAU,EAAE,mBAAmB,EAAE;AACxC;;AAEA;EACE;IACE,iFAAiF;EACnF;EACA;IACE,iFAAiF;EACnF;AACF;;AAEA;EACE,OAAO,wCAAwC,EAAE;EACjD,KAAK,6CAA6C,EAAE;AACtD;;AAEA;EACE,OAAO,UAAU,EAAE,uCAAuC,EAAE;EAC5D,KAAK,UAAU,EAAE,iCAAiC,EAAE;AACtD;;AAEA;EACE,KAAK,4BAA4B,EAAE;EACnC,YAAY,2BAA2B,EAAE;AAC3C;;AAEA;EACE,gBAAgB,wBAAwB,EAAE,aAAa,EAAE;EACzD,MAAM,2BAA2B,EAAE,UAAU,EAAE;AACjD;;AAEA;EACE,WAAW,gDAAgD,EAAE;EAC7D,MAAM,gDAAgD,EAAE;AAC1D;;AAEA;EACE,KAAK,4BAA4B,EAAE;EACnC,YAAY,2BAA2B,EAAE;AAC3C;;AAEA;EACE,WAAW,YAAY,EAAE,mBAAmB,EAAE;EAC9C,MAAM,aAAa,EAAE,sBAAsB,EAAE;AAC/C;;AAEA;EACE,OAAO,UAAU,EAAE,uCAAuC,EAAE;EAC5D,KAAK,UAAU,EAAE,iCAAiC,EAAE;AACtD;;AAEA;EACE,OAAO,uBAAuB,EAAE;EAChC,KAAK,yBAAyB,EAAE;AAClC;;AAEA;EACE,KAAK,QAAQ,EAAE;EACf,OAAO,WAAW,EAAE;AACtB;;AAEA;EACE;IACE,mBAAmB;IACnB,gEAAgE;EAClE;EACA;IACE,sBAAsB;IACtB,iCAAiC;EACnC;EACA;IACE,mBAAmB;IACnB,+BAA+B;EACjC;AACF;;AAEA;EACE;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;IAgCE,0BAA0B;IAC1B,2BAA2B;EAC7B;AACF;;AAEA;EACE;IACE,wCAAwC;EAC1C;AACF;;AAEA;EACE;;IAEE,gCAAgC;EAClC;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,aAAa;EACf;AACF;;AAEA;EACE;;IAEE,0BAA0B;IAC1B,iCAAiC;IACjC,YAAY;IACZ,iBAAiB;IACjB,cAAc;EAChB;;EAEA;IACE,WAAW;IACX,cAAc;EAChB;;EAEA;IACE,WAAW;IACX,cAAc;EAChB;;EAEA;IACE,WAAW;IACX,cAAc;IACd,aAAa;EACf;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,mBAAmB;IACnB,sBAAsB;EACxB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,aAAa;IACb,cAAc;EAChB;AACF","sourcesContent":["/* AuditOS Styles */\n.audit-layout {\n  display: grid;\n  grid-template-columns: 15.5rem 1fr 22rem;\n  grid-template-rows: auto 1fr;\n  height: 100vh;\n  overflow: hidden;\n  background:\n    radial-gradient(circle at top left, rgba(99, 102, 241, 0.2), transparent 22%),\n    radial-gradient(circle at top right, rgba(34, 211, 238, 0.14), transparent 24%),\n    linear-gradient(180deg, #eef2ff 0%, #e0f2fe 100%);\n  font-family: \"Manrope\", \"Segoe UI\", Arial, sans-serif;\n}\n\n.audit-layout.chat-closed {\n  grid-template-columns: 15.5rem 1fr 0;\n}\n\n.audit-sidebar {\n  grid-row: 1 / -1;\n  grid-column: 1;\n}\n\n.sidebar-enter {\n  animation: sidebarIn 500ms cubic-bezier(0.2, 0.9, 0.2, 1) both;\n}\n\n.audit-sidebar {\n  background:\n    radial-gradient(circle at top left, rgba(99, 102, 241, 0.14), transparent 24%),\n    linear-gradient(180deg, rgba(255, 255, 255, 0.92) 0%, rgba(244, 247, 255, 0.96) 48%, rgba(236, 242, 255, 0.98) 100%);\n}\n\n.audit-brand {\n  position: relative;\n}\n\n.audit-brand::before {\n  content: \"\";\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  height: 3px;\n  background: linear-gradient(90deg, #6366f1, #22d3ee, #a78bfa);\n  opacity: 0.95;\n}\n\n.audit-panel {\n  background: linear-gradient(180deg, rgba(255, 255, 255, 0.52), rgba(255, 255, 255, 0.18));\n}\n\n.audit-active-audit {\n  background: rgba(255, 255, 255, 0.55);\n  border: 1px solid rgba(148, 163, 184, 0.18);\n  border-radius: 10px;\n  padding: 6px 8px;\n  display: flex;\n  align-items: center;\n  gap: 6px;\n}\n\n.audit-health-pulse {\n  width: 7px;\n  height: 7px;\n  border-radius: 999px;\n  display: inline-block;\n  animation: healthPulse 1.9s ease-in-out infinite;\n}\n\n.audit-health-pulse.good {\n  background: #22c55e;\n  --pulse-color: rgba(34, 197, 94, 0.45);\n}\n\n.audit-health-pulse.warn {\n  background: #f59e0b;\n  --pulse-color: rgba(245, 158, 11, 0.45);\n}\n\n.audit-health-pulse.risk {\n  background: #ef4444;\n  --pulse-color: rgba(239, 68, 68, 0.45);\n}\n\n.section-dot {\n  width: 4px;\n  height: 4px;\n  border-radius: 999px;\n  background: #2563eb;\n  box-shadow: 0 0 10px rgba(37, 99, 235, 0.55);\n}\n\n.audit-chip {\n  color: #cbd5e1;\n  border: 1px solid transparent;\n  background: rgba(255, 255, 255, 0.02);\n}\n\n.audit-chip:hover {\n  background: rgba(255, 255, 255, 0.07);\n}\n\n.audit-chip.active {\n  background: rgba(37, 99, 235, 0.16);\n  border-color: rgba(37, 99, 235, 0.45);\n  color: #eff6ff;\n  box-shadow: inset 0 0 0 1px rgba(37, 99, 235, 0.22);\n}\n\n.audit-header {\n  grid-row: 1;\n  grid-column: 2;\n}\n\n.audit-main {\n  grid-row: 2;\n  grid-column: 2;\n  overflow-y: auto;\n  position: relative;\n  background:\n    radial-gradient(circle at top right, rgba(129, 140, 248, 0.18), transparent 22%),\n    radial-gradient(circle at top left, rgba(34, 211, 238, 0.1), transparent 20%),\n    linear-gradient(180deg, #f7fbff 0%, #eef2ff 100%);\n  box-shadow:\n    inset 1px 0 0 #c7d2fe,\n    inset -1px 0 0 #c7d2fe,\n    inset 0 -1px 0 #c7d2fe;\n}\n\n.audit-main::before {\n  content: \"\";\n  position: absolute;\n  inset: 0 0 auto 0;\n  height: 196px;\n  background:\n    radial-gradient(circle at top right, rgba(34, 211, 238, 0.22), transparent 30%),\n    linear-gradient(120deg, #1d4ed8 0%, #4f46e5 46%, #7c3aed 100%);\n  z-index: 0;\n}\n\n.audit-main > * {\n  position: relative;\n  z-index: 1;\n}\n\n.dark .audit-main {\n  background: #121722;\n  box-shadow:\n    inset 1px 0 0 #292f3b,\n    inset -1px 0 0 #292f3b,\n    inset 0 -1px 0 #292f3b;\n}\n\n.dark .audit-main::before {\n  background:\n    radial-gradient(circle at top right, rgba(34, 211, 238, 0.14), transparent 28%),\n    linear-gradient(120deg, #1e3a8a 0%, #4f46e5 42%, #0b1220 100%);\n}\n\n.dark .audit-main .bg-card,\n.dark .audit-main [class*=\"bg-card/\"],\n.dark .audit-main .bg-background {\n  background-color: hsl(var(--card)) !important;\n}\n\n.audit-chat {\n  grid-row: 1 / -1;\n  grid-column: 3;\n  transition: width 200ms ease;\n  border-left: 1px solid hsl(var(--border));\n  background: linear-gradient(180deg, rgba(255, 255, 255, 0.94) 0%, rgba(238, 242, 255, 0.98) 100%);\n}\n\n/* Phase progress */\n.phase-step {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  flex: 1;\n}\n\n.phase-step-dot {\n  width: 28px;\n  height: 28px;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 11px;\n  font-weight: 600;\n  z-index: 1;\n  transition: all 200ms ease;\n  animation: phaseDotIn 420ms cubic-bezier(0.2, 0.9, 0.2, 1) both;\n  animation-delay: var(--phase-delay, 0ms);\n}\n\n.phase-step-line {\n  position: absolute;\n  top: 14px;\n  left: 50%;\n  width: 100%;\n  height: 2px;\n  z-index: 0;\n  background: hsl(var(--border));\n  overflow: hidden;\n}\n\n.phase-step-line::after {\n  content: \"\";\n  position: absolute;\n  inset: 0;\n  transform-origin: left center;\n  transform: scaleX(0);\n  background: linear-gradient(90deg, hsl(var(--primary)), hsl(var(--chart-2)));\n}\n\n.phase-step-line.is-active::after {\n  animation: progressGrow 900ms cubic-bezier(0.2, 0.8, 0.2, 1) both;\n  animation-delay: calc(var(--phase-delay, 0ms) + 120ms);\n}\n\n.phase-step-button:hover .phase-step-dot {\n  transform: translateY(-2px) scale(1.04);\n  box-shadow: 0 0 0 6px rgba(99, 102, 241, 0.08);\n}\n\n.phase-step-dot.is-current {\n  box-shadow: 0 0 0 6px rgba(99, 102, 241, 0.12), 0 0 22px rgba(99, 102, 241, 0.26);\n  animation:\n    phaseDotIn 420ms cubic-bezier(0.2, 0.9, 0.2, 1) both,\n    currentPhasePulse 2.6s ease-in-out infinite;\n  animation-delay: var(--phase-delay, 0ms), calc(var(--phase-delay, 0ms) + 420ms);\n}\n\n.phase-step-dot.is-complete {\n  box-shadow: 0 0 0 4px rgba(16, 185, 129, 0.1);\n}\n\n.phase-progress-shell .phase-step span {\n  animation: rowIn 320ms ease both;\n  animation-delay: calc(var(--phase-delay, 0ms) + 120ms);\n}\n\n/* Labels */\n.label-xs {\n  font-size: 10px;\n  font-weight: 600;\n  letter-spacing: 0.1em;\n  text-transform: uppercase;\n}\n\n/* Data table density */\n.table-dense th,\n.table-dense td {\n  padding: 0.5rem 0.75rem;\n  font-size: 0.8125rem;\n}\n\n.table-dense th {\n  font-size: 0.6875rem;\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n}\n\n/* Severity badges */\n.severity-high { @apply bg-red-50 text-red-700 border-red-200 dark:bg-red-950/30 dark:text-red-400 dark:border-red-900; }\n.severity-medium { @apply bg-amber-50 text-amber-700 border-amber-200 dark:bg-amber-950/30 dark:text-amber-400 dark:border-amber-900; }\n.severity-low { @apply bg-blue-50 text-blue-700 border-blue-200 dark:bg-blue-950/30 dark:text-blue-400 dark:border-blue-900; }\n.severity-observation { @apply bg-slate-50 text-slate-700 border-slate-200 dark:bg-slate-950/30 dark:text-slate-400 dark:border-slate-900; }\n\n/* Status indicators */\n.status-dot {\n  width: 8px;\n  height: 8px;\n  border-radius: 50%;\n  display: inline-block;\n}\n\n.status-ready { @apply bg-emerald-500; }\n.status-ingesting { @apply bg-amber-500 animate-pulse; }\n.status-parsing { @apply bg-blue-500 animate-pulse; }\n.status-extracting { @apply bg-violet-500 animate-pulse; }\n.status-uploaded { @apply bg-slate-400; }\n\n/* Chat message animation */\n@keyframes fadeInUp {\n  from { opacity: 0; transform: translateY(8px); }\n  to { opacity: 1; transform: translateY(0); }\n}\n\n.chat-message-enter {\n  animation: fadeInUp 200ms ease-out;\n}\n\n/* Ambient Motion Layer */\n.ambient-canvas {\n  position: relative;\n  isolation: isolate;\n}\n\n.audit-main .ambient-orb,\n.audit-main .ambient-particles {\n  display: block;\n}\n\n/* Keep dashboard content white over the orange surface */\n.audit-main .bg-card,\n.audit-main [class*=\"bg-card/\"],\n.audit-main .bg-background {\n  background-color: #ffffff !important;\n}\n\n.audit-main .border {\n  border-color: rgba(129, 140, 248, 0.28);\n}\n\n/* Make top phase header text readable over the dark-teal hero strip */\n.audit-main [data-testid^=\"phase-\"] > div:first-child h2 {\n  color: #ffffff !important;\n  text-shadow: 0 1px 1px rgba(2, 6, 23, 0.4);\n}\n\n.audit-main [data-testid^=\"phase-\"] > div:first-child p {\n  color: #dbeafe !important;\n}\n\n.audit-main [data-testid^=\"phase-\"] {\n  animation: phasePageIn 560ms cubic-bezier(0.2, 0.9, 0.2, 1) both;\n}\n\n.audit-main [data-testid^=\"phase-\"] > * {\n  animation: phaseSectionIn 520ms cubic-bezier(0.2, 0.9, 0.2, 1) both;\n}\n\n.audit-main [data-testid^=\"phase-\"] > *:nth-child(1) { animation-delay: 40ms; }\n.audit-main [data-testid^=\"phase-\"] > *:nth-child(2) { animation-delay: 110ms; }\n.audit-main [data-testid^=\"phase-\"] > *:nth-child(3) { animation-delay: 180ms; }\n.audit-main [data-testid^=\"phase-\"] > *:nth-child(4) { animation-delay: 250ms; }\n.audit-main [data-testid^=\"phase-\"] > *:nth-child(5) { animation-delay: 320ms; }\n\n/* Phase 7 command-center treatment */\n.phase7-hero {\n  position: relative;\n  isolation: isolate;\n  border-color: rgba(129, 140, 248, 0.28);\n  background:\n    linear-gradient(135deg, rgba(15, 23, 42, 0.98) 0%, rgba(15, 23, 42, 0.94) 48%, rgba(30, 27, 75, 0.96) 100%),\n    radial-gradient(circle at 12% 0%, rgba(45, 212, 191, 0.28), transparent 28%),\n    radial-gradient(circle at 88% 18%, rgba(129, 140, 248, 0.24), transparent 34%);\n  box-shadow: 0 24px 60px rgba(2, 6, 23, 0.32), inset 0 1px 0 rgba(255, 255, 255, 0.08);\n  animation: heroGradientDrift 14s ease-in-out infinite alternate;\n}\n\n.phase7-hero::after {\n  content: \"\";\n  position: absolute;\n  inset: 0;\n  z-index: -1;\n  background-image:\n    linear-gradient(rgba(148, 163, 184, 0.08) 1px, transparent 1px),\n    linear-gradient(90deg, rgba(148, 163, 184, 0.08) 1px, transparent 1px);\n  background-size: 44px 44px;\n  mask-image: linear-gradient(180deg, black, transparent 78%);\n}\n\n.phase7-hero p,\n.phase7-hero h2 {\n  color: inherit !important;\n}\n\n.phase7-hero .text-slate-300 {\n  color: #cbd5e1 !important;\n}\n\n.phase7-hero .text-slate-400 {\n  color: #94a3b8 !important;\n}\n\n.phase7-hero .text-cyan-200\\/90 {\n  color: rgba(165, 243, 252, 0.9) !important;\n}\n\n.phase7-stat {\n  backdrop-filter: blur(10px);\n  transition: transform 180ms ease, border-color 180ms ease, background 180ms ease;\n}\n\n.phase7-stat:hover {\n  transform: translateY(-2px);\n  border-color: rgba(45, 212, 191, 0.36);\n  background: rgba(255, 255, 255, 0.09);\n}\n\n.phase7-console-card,\n.phase7-control-row,\n.phase7-progress-card {\n  animation: phaseSectionIn 480ms cubic-bezier(0.2, 0.9, 0.2, 1) both;\n}\n\n.phase7-console-card {\n  overflow: hidden;\n  box-shadow: 0 18px 42px rgba(2, 6, 23, 0.08);\n}\n\n.dark .phase7-console-card {\n  background:\n    linear-gradient(180deg, rgba(23, 29, 46, 0.94), rgba(15, 23, 42, 0.96)) !important;\n  border-color: rgba(129, 140, 248, 0.22) !important;\n  box-shadow: 0 22px 46px rgba(0, 0, 0, 0.26), inset 0 1px 0 rgba(255, 255, 255, 0.04);\n}\n\n.dark .phase7-control-panel,\n.dark .phase7-progress-card {\n  background: rgba(2, 6, 23, 0.28) !important;\n  border-color: rgba(148, 163, 184, 0.18) !important;\n}\n\n.dark .phase7-control-row {\n  background: rgba(15, 23, 42, 0.72) !important;\n  border-color: rgba(148, 163, 184, 0.16) !important;\n}\n\n.dark .phase7-control-row:hover {\n  border-color: rgba(45, 212, 191, 0.34) !important;\n}\n\n/* Phase 10 readability on orange + white dashboard */\n.phase10-readable,\n.phase10-readable * {\n  color: #0f172a;\n}\n\n.phase10-readable .text-muted-foreground {\n  color: #111827 !important;\n}\n\n.phase10-readable .text-\\[10px\\],\n.phase10-readable .text-\\[9px\\],\n.phase10-readable .text-\\[8px\\] {\n  color: #1f2937 !important;\n}\n\n.phase10-no-gap {\n  margin: -24px -24px 0;\n  padding: 0 8px 24px;\n}\n\n.phase10-report-header {\n  margin: 0 -8px;\n  padding: 18px 20px;\n  border: 1px solid rgba(129, 140, 248, 0.24);\n  border-radius: 18px;\n  background:\n    radial-gradient(circle at top right, rgba(34, 211, 238, 0.16), transparent 30%),\n    linear-gradient(120deg, #1e3a8a 0%, #4f46e5 42%, #111827 100%);\n  box-shadow: 0 18px 42px rgba(2, 6, 23, 0.22);\n}\n\n.phase10-report-header-attached {\n  border-bottom-color: rgba(255, 255, 255, 0.08);\n  border-bottom-right-radius: 0;\n  border-bottom-left-radius: 0;\n}\n\n.phase10-report-header .bg-white\\/80,\n.phase10-report-header [class*=\"bg-card\"],\n.phase10-report-header [class*=\"bg-background\"] {\n  background-color: rgba(15, 23, 42, 0.72) !important;\n}\n\n.phase10-report-header button,\n.phase10-report-header [role=\"combobox\"] {\n  border-color: rgba(255, 255, 255, 0.18) !important;\n  color: #ffffff;\n}\n\n.phase10-report-header button:hover,\n.phase10-report-header [role=\"combobox\"]:hover {\n  background-color: rgba(255, 255, 255, 0.12) !important;\n}\n\n.phase10-command-brief {\n  margin-top: -1.5rem !important;\n  border-top-right-radius: 0 !important;\n  border-top-left-radius: 0 !important;\n}\n\n.ambient-orb {\n  position: fixed;\n  pointer-events: none;\n  z-index: 0;\n  filter: blur(34px);\n  opacity: 0.2;\n  border-radius: 9999px;\n  animation: orbFloat 10s ease-in-out infinite alternate;\n}\n\n.orb-one {\n  width: 280px;\n  height: 280px;\n  right: 14%;\n  top: 18%;\n  background: radial-gradient(circle, rgba(37,99,235,0.35) 0%, rgba(37,99,235,0) 70%);\n}\n\n.orb-two {\n  width: 220px;\n  height: 220px;\n  right: 34%;\n  bottom: 8%;\n  background: radial-gradient(circle, rgba(96,165,250,0.28) 0%, rgba(96,165,250,0) 70%);\n  animation-delay: 1.2s;\n}\n\n.ambient-particles {\n  position: fixed;\n  inset: 0;\n  pointer-events: none;\n  z-index: 0;\n  background-image:\n    radial-gradient(circle at 10% 18%, rgba(96,165,250,0.22) 1px, transparent 1.6px),\n    radial-gradient(circle at 70% 35%, rgba(37,99,235,0.18) 1px, transparent 1.6px),\n    radial-gradient(circle at 35% 72%, rgba(147,197,253,0.16) 1px, transparent 1.6px);\n  background-size: 320px 320px, 260px 260px, 380px 380px;\n  animation: particlesDrift 16s linear infinite;\n  display: none;\n}\n\n/* Sidebar and Nav Animations */\n.sidebar-logo-anim {\n  transform-origin: center;\n  transition: transform 220ms cubic-bezier(0.2, 0.8, 0.2, 1);\n}\n\n.sidebar-logo-anim:hover {\n  transform: rotate(-7deg) scale(1.06);\n}\n\n.sidebar-nav-item {\n  position: relative;\n  overflow: hidden;\n  animation: navItemIn 420ms cubic-bezier(0.2, 0.9, 0.2, 1) both;\n  animation-delay: var(--stagger, 0ms);\n  transition: transform 170ms ease, box-shadow 170ms ease;\n}\n\n.sidebar-nav-item:hover {\n  transform: translateX(3px);\n}\n\n.sidebar-nav-item .nav-icon {\n  transition: transform 180ms ease, color 180ms ease;\n}\n\n.sidebar-nav-item:hover .nav-icon {\n  transform: scale(1.08);\n  color: #60a5fa;\n}\n\n.sidebar-nav-item.active::before {\n  content: \"\";\n  position: absolute;\n  left: 0;\n  top: 18%;\n  height: 64%;\n  width: 3px;\n  border-radius: 999px;\n  background: #2563eb;\n  box-shadow: 0 0 12px rgba(37, 99, 235, 0.55);\n}\n\n.sidebar-stepper {\n  position: relative;\n}\n\n.sidebar-stepper::before {\n  content: \"\";\n  position: absolute;\n  left: 18px;\n  top: 44px;\n  bottom: 18px;\n  width: 1px;\n  background: linear-gradient(180deg, rgba(255, 255, 255, 0.08), rgba(37, 99, 235, 0.45), rgba(255, 255, 255, 0.08));\n}\n\n.sidebar-stepper .sidebar-nav-item {\n  padding-left: 0.95rem;\n}\n\n.sidebar-journey-progress {\n  background: linear-gradient(90deg, #6366f1 0%, #8b5cf6 50%, #a855f7 100%);\n  box-shadow: 0 0 14px rgba(139, 92, 246, 0.35);\n  transition: width 260ms ease;\n}\n\n.sidebar-stepper .sidebar-nav-item .ml-auto {\n  height: 7px;\n  width: 7px;\n  border-radius: 999px;\n  background: #8b5cf6;\n  box-shadow: 0 0 10px rgba(139, 92, 246, 0.55);\n}\n\n.sidebar-stepper .sidebar-nav-item.is-complete .nav-icon {\n  color: #c4b5fd;\n}\n\n.sidebar-profile-avatar {\n  box-shadow: 0 0 0 1px rgba(99, 102, 241, 0.12), 0 8px 20px rgba(30, 41, 59, 0.18);\n}\n\n.profile-summary-avatar {\n  box-shadow: 0 0 0 1px rgba(99, 102, 241, 0.12), 0 10px 24px rgba(30, 41, 59, 0.2);\n}\n\n/* Quick Action Micro-Interaction */\n.quick-action {\n  transition: transform 160ms ease, color 160ms ease;\n}\n\n.quick-action:hover {\n  transform: translateX(4px);\n}\n\n/* Metric Card Entrance + Hover Lift */\n.metric-card-anim {\n  position: relative;\n  overflow: hidden;\n  animation: metricIn 580ms cubic-bezier(0.2, 0.9, 0.15, 1.1) both;\n  animation-delay: var(--delay, 0ms);\n  transition: transform 180ms ease, box-shadow 180ms ease;\n}\n\n.metric-card-anim::after {\n  content: \"\";\n  position: absolute;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  height: 2px;\n  background: linear-gradient(90deg, rgba(37,99,235,0), rgba(37,99,235,0.85), rgba(37,99,235,0));\n  opacity: 0;\n  transform: translateY(2px);\n  transition: opacity 180ms ease, transform 180ms ease;\n}\n\n.metric-card-anim:hover {\n  transform: translateY(-3px);\n  box-shadow: 0 8px 18px rgba(15, 23, 42, 0.08);\n}\n\n.metric-card-anim:hover::after {\n  opacity: 1;\n  transform: translateY(0);\n}\n\n.audit-card {\n  position: relative;\n  overflow: hidden;\n}\n\n.audit-card::before {\n  content: \"\";\n  position: absolute;\n  inset: 0;\n  background: linear-gradient(115deg, transparent 0%, rgba(255, 255, 255, 0.08) 18%, transparent 36%);\n  opacity: 0;\n  transform: translateX(-18%);\n  transition: opacity 220ms ease, transform 420ms ease;\n  pointer-events: none;\n}\n\n.audit-card:hover::before {\n  opacity: 1;\n  transform: translateX(18%);\n}\n\n.dark .audit-card:hover {\n  box-shadow: 0 24px 50px rgba(2, 6, 23, 0.34), inset 0 1px 0 rgba(255, 255, 255, 0.03);\n}\n\n.executive-glass {\n  background: linear-gradient(140deg, rgba(255, 255, 255, 0.86), rgba(255, 245, 236, 0.72)) !important;\n  border: 1px solid rgba(37, 99, 235, 0.18) !important;\n  box-shadow: 0 16px 34px rgba(37, 99, 235, 0.08), inset 0 1px 0 rgba(255, 255, 255, 0.55);\n  backdrop-filter: blur(10px);\n}\n\n.dark .executive-glass {\n  background: linear-gradient(140deg, rgba(26, 26, 27, 0.72), rgba(17, 24, 39, 0.55)) !important;\n  border-color: rgba(45, 212, 191, 0.35) !important;\n  box-shadow: 0 10px 28px rgba(0, 0, 0, 0.38), inset 0 1px 0 rgba(255, 255, 255, 0.05);\n}\n\n.executive-hero {\n  background: linear-gradient(120deg, #1d4ed8 0%, #2563eb 52%, #60a5fa 100%) !important;\n  box-shadow: 0 16px 30px rgba(29, 78, 216, 0.18);\n}\n\n.hero-progress-wrap {\n  min-width: 250px;\n  background: rgba(255, 255, 255, 0.18);\n  border: 1px solid rgba(255, 241, 229, 0.42);\n  border-radius: 16px;\n  padding: 12px;\n  backdrop-filter: blur(6px);\n}\n\n.hero-progress-label {\n  display: flex;\n  justify-content: space-between;\n  font-size: 11px;\n  color: rgba(255, 255, 255, 0.95);\n  font-weight: 700;\n}\n\n.hero-progress-track {\n  height: 8px;\n  border-radius: 999px;\n  margin-top: 8px;\n  background: rgba(191, 219, 254, 0.38);\n  overflow: hidden;\n}\n\n.hero-progress-fill {\n  height: 100%;\n  border-radius: 999px;\n  background: linear-gradient(90deg, #fff6ed, #ffffff);\n  animation: progressGrow 900ms cubic-bezier(0.2, 0.8, 0.2, 1) both;\n  position: relative;\n  overflow: hidden;\n}\n\n.hero-progress-fill::after,\n.quick-actions-fill::after,\n.assistant-task-fill::after {\n  content: \"\";\n  position: absolute;\n  inset: 0;\n  background: linear-gradient(90deg, transparent 0%, rgba(255, 255, 255, 0.5) 48%, transparent 100%);\n  transform: translateX(-120%);\n  animation: scanSweep 1.9s ease-in-out infinite;\n}\n\n/* Table Row Reveal + Progress */\n.table-row-anim {\n  animation: rowIn 380ms ease both;\n  animation-delay: var(--row-delay, 0ms);\n}\n\n.audit-main table tbody tr {\n  animation: rowIn 420ms ease both;\n}\n\n.audit-main table tbody tr:nth-child(1) { animation-delay: 50ms; }\n.audit-main table tbody tr:nth-child(2) { animation-delay: 90ms; }\n.audit-main table tbody tr:nth-child(3) { animation-delay: 130ms; }\n.audit-main table tbody tr:nth-child(4) { animation-delay: 170ms; }\n.audit-main table tbody tr:nth-child(5) { animation-delay: 210ms; }\n\n.progress-anim {\n  transform-origin: left center;\n  animation: progressGrow 900ms cubic-bezier(0.2, 0.8, 0.2, 1) both;\n  animation-delay: 120ms;\n}\n\n.progress-bar-indicator {\n  position: relative;\n  overflow: hidden;\n}\n\n.progress-bar-indicator::after {\n  content: \"\";\n  position: absolute;\n  inset: 0;\n  background: linear-gradient(90deg, transparent 0%, rgba(255, 255, 255, 0.35) 45%, transparent 100%);\n  transform: translateX(-125%);\n  animation: scanSweep 2.1s ease-in-out infinite;\n}\n\n/* Notification Pulse */\n.notification-pulse {\n  animation: bellPulse 1.8s ease-in-out infinite;\n}\n\n/* Floating AI Button */\n.floating-ai-btn {\n  position: fixed;\n  right: 1.2rem;\n  bottom: 1.2rem;\n  z-index: 40;\n  display: inline-flex;\n  align-items: center;\n  gap: 0.45rem;\n  border-radius: 999px;\n  background: linear-gradient(135deg, #1d4ed8, #3b82f6);\n  color: white;\n  box-shadow: 0 16px 32px rgba(29, 78, 216, 0.28);\n  animation: floatBtnIn 540ms cubic-bezier(0.2, 0.95, 0.2, 1.2) both;\n}\n\n.audit-chat-panel {\n  background: linear-gradient(180deg, rgba(255, 255, 255, 0.96) 0%, rgba(241, 245, 255, 0.98) 100%);\n  color: hsl(var(--foreground));\n}\n\n.audit-chat-panel .chat-header {\n  background: rgba(255, 255, 255, 0.72);\n  border-color: hsl(var(--border));\n}\n\n.audit-chat-panel .chat-composer {\n  background: rgba(255, 255, 255, 0.78);\n  border-color: hsl(var(--border));\n}\n\n.dark .audit-sidebar {\n  background:\n    radial-gradient(circle at top left, rgba(59, 130, 246, 0.16), transparent 24%),\n    linear-gradient(180deg, #171a22 0%, #11131a 48%, #0f1117 100%);\n}\n\n.dark .audit-sidebar .text-muted-foreground {\n  color: #cbd5e1 !important;\n}\n\n.dark .audit-sidebar .label-xs {\n  color: #dbeafe !important;\n}\n\n.dark .audit-sidebar .sidebar-nav-item {\n  color: #cbd5e1;\n}\n\n.dark .audit-sidebar .sidebar-nav-item:hover {\n  background: rgba(99, 102, 241, 0.16);\n  color: #f8fafc;\n}\n\n.dark .audit-sidebar .sidebar-nav-item.active {\n  color: #ffffff;\n  background: rgba(99, 102, 241, 0.18);\n}\n\n.dark .sidebar-stepper::before {\n  background: linear-gradient(180deg, rgba(139, 92, 246, 0.12), rgba(139, 92, 246, 0.3), rgba(139, 92, 246, 0.12));\n}\n\n.dark .sidebar-journey-progress {\n  background: linear-gradient(90deg, #6366f1 0%, #8b5cf6 52%, #a855f7 100%);\n  box-shadow: 0 0 18px rgba(139, 92, 246, 0.38);\n}\n\n.dark .audit-panel {\n  background: linear-gradient(180deg, rgba(255, 255, 255, 0.04), rgba(255, 255, 255, 0.01));\n}\n\n.dark .audit-active-audit {\n  background: rgba(15, 23, 42, 0.72);\n  border-color: rgba(129, 140, 248, 0.28);\n  color: #e2e8f0 !important;\n}\n\n.dark .audit-active-audit .text-foreground {\n  color: #ffffff !important;\n}\n\n.dark .audit-active-audit .text-muted-foreground {\n  color: #cbd5e1 !important;\n}\n\n.dark .audit-chat {\n  border-left-color: rgba(148, 163, 184, 0.18);\n  background: linear-gradient(180deg, #111827 0%, #0f172a 100%);\n}\n\n.dark .audit-chat-panel {\n  background: linear-gradient(180deg, #1c1f29 0%, #12151c 100%);\n  color: #fff7ed;\n}\n\n.dark .audit-chat-panel .chat-header {\n  background: rgba(15, 23, 42, 0.86);\n  border-color: rgba(148, 163, 184, 0.2);\n}\n\n.dark .audit-chat-panel .chat-composer {\n  background: rgba(15, 23, 42, 0.92);\n  border-color: rgba(148, 163, 184, 0.2);\n}\n\n.copilot-shell {\n  background:\n    radial-gradient(circle at top right, rgba(129, 140, 248, 0.12), transparent 28%),\n    linear-gradient(180deg, #111827 0%, #0b1220 100%) !important;\n  color: #e5e7eb;\n}\n\n.copilot-header {\n  padding: 18px 16px;\n  background: rgba(15, 23, 42, 0.86) !important;\n  border-color: rgba(148, 163, 184, 0.18) !important;\n  box-shadow: 0 12px 30px rgba(2, 6, 23, 0.24);\n}\n\n.copilot-title {\n  color: #a5b4fc;\n  text-shadow: 0 0 18px rgba(129, 140, 248, 0.26);\n}\n\n.copilot-context {\n  color: #94a3b8;\n  letter-spacing: 0.18em;\n}\n\n.copilot-avatar {\n  border: 2px solid rgba(199, 210, 254, 0.86);\n  box-shadow: 0 0 24px rgba(129, 140, 248, 0.24);\n}\n\n.copilot-icon-btn {\n  color: #a5b4fc !important;\n  background: rgba(15, 23, 42, 0.44) !important;\n  border: 1px solid rgba(129, 140, 248, 0.14);\n}\n\n.copilot-icon-btn:hover {\n  background: rgba(129, 140, 248, 0.16) !important;\n  color: #ddd6fe !important;\n}\n\n.copilot-scroll {\n  background:\n    linear-gradient(90deg, rgba(30, 41, 59, 0.08) 1px, transparent 1px),\n    linear-gradient(180deg, rgba(30, 41, 59, 0.08) 1px, transparent 1px);\n  background-size: 44px 44px;\n}\n\n.copilot-day-divider {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  color: #94a3b8;\n  font-size: 12px;\n  font-weight: 700;\n}\n\n.copilot-day-divider::before,\n.copilot-day-divider::after {\n  content: \"\";\n  height: 1px;\n  flex: 1;\n  background: rgba(148, 163, 184, 0.14);\n}\n\n.copilot-day-divider {\n  animation: phaseSectionIn 420ms cubic-bezier(0.2, 0.9, 0.2, 1) both;\n}\n\n.copilot-context-card {\n  background: rgba(15, 23, 42, 0.54) !important;\n  border-color: rgba(99, 102, 241, 0.24) !important;\n  border-radius: 16px;\n}\n\n.copilot-welcome {\n  background: linear-gradient(135deg, rgba(20, 184, 166, 0.18), rgba(99, 102, 241, 0.12)) !important;\n  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.04);\n}\n\n.copilot-welcome .bg-primary {\n  background: linear-gradient(135deg, #6366f1, #8b5cf6) !important;\n}\n\n.copilot-welcome .bg-primary:hover {\n  background: linear-gradient(135deg, #818cf8, #a78bfa) !important;\n}\n\n.copilot-bot-mark {\n  background: linear-gradient(135deg, #6366f1, #8b5cf6);\n  color: #eef2ff;\n  box-shadow: 0 12px 26px rgba(79, 70, 229, 0.28);\n  position: relative;\n  overflow: hidden;\n}\n\n.copilot-user-mark {\n  background: rgba(20, 184, 166, 0.14);\n  color: #99f6e4;\n  border: 1px solid rgba(45, 212, 191, 0.18);\n}\n\n.copilot-message-row {\n  animation: messageSlideIn 520ms cubic-bezier(0.2, 0.9, 0.2, 1) both;\n  animation-delay: var(--message-delay, 0ms);\n}\n\n.message-user-row {\n  transform-origin: right center;\n}\n\n.message-assistant-row {\n  transform-origin: left center;\n}\n\n.copilot-message {\n  border-radius: 20px;\n  box-shadow: 0 16px 34px rgba(2, 6, 23, 0.2);\n  position: relative;\n  overflow: hidden;\n}\n\n.copilot-user-message {\n  border-top-right-radius: 6px;\n  background: linear-gradient(135deg, #6366f1, #8b5cf6 58%, #22d3ee);\n  box-shadow: 0 16px 34px rgba(79, 70, 229, 0.26);\n}\n\n.copilot-user-message::after {\n  content: \"\";\n  position: absolute;\n  inset: 0;\n  background: linear-gradient(110deg, transparent 0%, rgba(255, 255, 255, 0.22) 26%, transparent 48%);\n  transform: translateX(-120%);\n  animation: messageShimmer 4.2s ease-in-out infinite;\n}\n\n.copilot-assistant-message {\n  border-top-left-radius: 6px;\n  background:\n    linear-gradient(180deg, rgba(20, 27, 43, 0.96), rgba(15, 23, 42, 0.96)) !important;\n  border-color: rgba(129, 140, 248, 0.18) !important;\n}\n\n.copilot-assistant-message::before {\n  content: \"\";\n  position: absolute;\n  inset: auto -20% 0 -20%;\n  height: 1px;\n  background: linear-gradient(90deg, transparent 0%, rgba(45, 212, 191, 0.42) 50%, transparent 100%);\n}\n\n.copilot-message-text {\n  color: #e5e7eb;\n}\n\n.copilot-message-text strong {\n  color: #2dd4bf;\n  font-weight: 800;\n}\n\n.copilot-evidence-card {\n  background: rgba(2, 6, 23, 0.22);\n  border-radius: 12px;\n  padding: 8px;\n}\n\n.copilot-composer {\n  background: rgba(15, 23, 42, 0.92) !important;\n  border-color: rgba(148, 163, 184, 0.18) !important;\n}\n\n.copilot-chip {\n  border-color: rgba(129, 140, 248, 0.26) !important;\n  background: rgba(15, 23, 42, 0.64) !important;\n  color: #c7d2fe !important;\n}\n\n.copilot-chip:hover {\n  background: rgba(99, 102, 241, 0.18) !important;\n}\n\n.copilot-input-shell {\n  min-height: 56px;\n  border: 1px solid rgba(148, 163, 184, 0.18);\n  border-radius: 22px;\n  background: rgba(15, 23, 42, 0.9);\n  padding: 6px;\n  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.03), 0 18px 36px rgba(2, 6, 23, 0.22);\n}\n\n.copilot-input-icon {\n  color: #94a3b8 !important;\n}\n\n.copilot-input-icon:hover {\n  color: #c7d2fe !important;\n  background: rgba(129, 140, 248, 0.12) !important;\n}\n\n.copilot-send {\n  border-radius: 18px !important;\n  background: linear-gradient(135deg, #c4b5fd, #6366f1) !important;\n  color: #111827 !important;\n  box-shadow: 0 12px 28px rgba(99, 102, 241, 0.34);\n  position: relative;\n  overflow: hidden;\n}\n\n.copilot-send:hover {\n  background: linear-gradient(135deg, #ddd6fe, #818cf8) !important;\n  transform: translateY(-1px);\n}\n\n.copilot-send-armed {\n  animation: sendPulse 1.6s ease-in-out infinite;\n}\n\n.copilot-send-armed::after {\n  content: \"\";\n  position: absolute;\n  inset: 0;\n  background: linear-gradient(110deg, transparent 0%, rgba(255, 255, 255, 0.36) 40%, transparent 70%);\n  transform: translateX(-125%);\n  animation: messageShimmer 2.8s ease-in-out infinite;\n}\n\n.copilot-thinking-row {\n  animation: phaseSectionIn 320ms ease both;\n}\n\n.copilot-thinking-mark {\n  box-shadow: 0 0 0 8px rgba(99, 102, 241, 0.08), 0 0 24px rgba(45, 212, 191, 0.22);\n}\n\n.copilot-thinking-bubble {\n  border-color: rgba(129, 140, 248, 0.24);\n  background:\n    radial-gradient(circle at top right, rgba(45, 212, 191, 0.12), transparent 35%),\n    linear-gradient(180deg, rgba(20, 27, 43, 0.96), rgba(15, 23, 42, 0.96));\n  box-shadow: 0 12px 28px rgba(2, 6, 23, 0.2);\n}\n\n.copilot-typing-dots {\n  display: inline-flex;\n  gap: 4px;\n  align-items: center;\n}\n\n.copilot-typing-dots span {\n  width: 5px;\n  height: 5px;\n  border-radius: 999px;\n  background: linear-gradient(135deg, #2dd4bf, #a5b4fc);\n  animation: typingBounce 0.95s ease-in-out infinite;\n}\n\n.copilot-typing-dots span:nth-child(2) {\n  animation-delay: 0.12s;\n}\n\n.copilot-typing-dots span:nth-child(3) {\n  animation-delay: 0.24s;\n}\n\n.dark .assistant-overlay {\n  border-color: rgba(96, 165, 250, 0.24);\n  background: linear-gradient(135deg, rgba(29, 78, 216, 0.34), rgba(27, 31, 40, 0.95));\n  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.04);\n}\n\n.dark .assistant-overlay-card {\n  background: linear-gradient(145deg, rgba(28, 30, 39, 0.96), rgba(20, 22, 30, 0.98));\n  box-shadow: 0 12px 24px rgba(0, 0, 0, 0.24);\n}\n\n.dark .assistant-task-track {\n  background: rgba(59, 130, 246, 0.18);\n}\n\n.dark .quick-actions-item {\n  border-color: rgba(96, 165, 250, 0.2);\n  background: rgba(26, 28, 36, 0.88);\n  box-shadow: 0 10px 24px rgba(0, 0, 0, 0.2);\n}\n\n.dark .quick-actions-track {\n  background: rgba(71, 85, 105, 0.45);\n}\n\n.dark .executive-glass {\n  background: linear-gradient(140deg, rgba(33, 36, 46, 0.94), rgba(20, 23, 31, 0.88)) !important;\n  border-color: rgba(96, 165, 250, 0.18) !important;\n  box-shadow: 0 14px 32px rgba(0, 0, 0, 0.28), inset 0 1px 0 rgba(255, 255, 255, 0.03);\n}\n\n.dark .executive-hero {\n  background: linear-gradient(120deg, #1d4ed8 0%, #2563eb 40%, #0b1220 100%) !important;\n  box-shadow: 0 16px 30px rgba(0, 0, 0, 0.24);\n}\n\n.dark .phase10-command-brief,\n.phase10-command-brief {\n  background:\n    radial-gradient(circle at top right, rgba(34, 211, 238, 0.13), transparent 30%),\n    linear-gradient(120deg, #172554 0%, #312e81 45%, #0b1220 100%) !important;\n  border: 1px solid rgba(129, 140, 248, 0.24) !important;\n  box-shadow: 0 18px 42px rgba(2, 6, 23, 0.24);\n}\n\n.dark .hero-progress-wrap {\n  background: rgba(17, 24, 39, 0.34);\n  border-color: rgba(255, 234, 214, 0.12);\n}\n\n.dark .hero-progress-track {\n  background: rgba(255, 245, 235, 0.1);\n}\n\n.dark .hero-progress-fill {\n  background: linear-gradient(90deg, #bfdbfe, #e0f2fe);\n}\n\n.dark .phase10-readable,\n.dark .phase10-readable * {\n  color: hsl(var(--foreground));\n}\n\n.dark .phase10-readable .phase10-print-preview,\n.dark .phase10-readable .phase10-print-preview * {\n  color: #111827 !important;\n}\n\n.dark .phase10-readable .phase10-print-preview .text-muted-foreground,\n.dark .phase10-readable .phase10-print-preview [style*=\"color: #6b7280\"],\n.dark .phase10-readable .phase10-print-preview [style*=\"color:#6b7280\"],\n.dark .phase10-readable .phase10-print-preview [style*=\"color: #9ca3af\"],\n.dark .phase10-readable .phase10-print-preview [style*=\"color:#9ca3af\"] {\n  color: #4b5563 !important;\n}\n\n.dark .phase10-readable .phase10-print-preview [style*=\"color: #374151\"],\n.dark .phase10-readable .phase10-print-preview [style*=\"color:#374151\"] {\n  color: #374151 !important;\n}\n\n.dark .phase10-readable .phase10-print-preview h3,\n.dark .phase10-readable .phase10-print-preview table,\n.dark .phase10-readable .phase10-print-preview table td,\n.dark .phase10-readable .phase10-print-preview table th,\n.dark .phase10-readable .phase10-print-preview p,\n.dark .phase10-readable .phase10-print-preview span,\n.dark .phase10-readable .phase10-print-preview li {\n  color: #111827 !important;\n}\n\n.dark .phase10-readable .phase10-print-preview table th,\n.dark .phase10-readable .phase10-print-preview p[style*=\"color: #6b7280\"],\n.dark .phase10-readable .phase10-print-preview span[style*=\"color: #6b7280\"],\n.dark .phase10-readable .phase10-print-preview td[style*=\"color: #6b7280\"],\n.dark .phase10-readable .phase10-print-preview [style*=\"color:#6b7280\"] {\n  color: #4b5563 !important;\n}\n\n.dark .phase10-readable .phase10-print-preview .phase10-finding-card,\n.dark .phase10-readable .phase10-print-preview .phase10-finding-card * {\n  color: #f8fafc !important;\n}\n\n.dark .phase10-readable .text-muted-foreground {\n  color: #cbd5e1 !important;\n}\n\n.dark .phase10-readable .recharts-cartesian-axis-tick-value,\n.dark .phase10-readable .recharts-polar-angle-axis text,\n.dark .phase10-readable .recharts-polar-radius-axis text,\n.dark .phase10-readable .recharts-tooltip-wrapper {\n  fill: #cbd5e1;\n  color: #cbd5e1;\n}\n\n.dark [data-testid=\"header\"] {\n  background: rgba(12, 18, 32, 0.94);\n  border-bottom-color: rgba(255, 255, 255, 0.08);\n  box-shadow: 0 10px 35px rgba(0, 0, 0, 0.18);\n}\n\n.dark [data-testid=\"header\"] .header-kicker,\n.dark [data-testid=\"header\"] .header-search-results,\n.dark [data-testid=\"header\"] .header-date-pill,\n.dark [data-testid=\"header\"] .header-icon-btn {\n  background: rgba(15, 23, 42, 0.78);\n  border-color: rgba(129, 140, 248, 0.28);\n  color: #e2e8f0;\n}\n\n.dark [data-testid=\"header\"] .header-popover {\n  background: #0f172a;\n  border-color: rgba(129, 140, 248, 0.38);\n  color: #f8fafc;\n  box-shadow: 0 24px 60px rgba(0, 0, 0, 0.55);\n}\n\n.dark [data-testid=\"header\"] .header-popover > div:first-child {\n  background: #111c33;\n  border-bottom-color: rgba(129, 140, 248, 0.26);\n}\n\n.dark [data-testid=\"header\"] .header-title {\n  color: #f8fafc;\n}\n\n.dark [data-testid=\"header\"] .header-subtitle,\n.dark [data-testid=\"header\"] .header-empty,\n.dark [data-testid=\"header\"] .header-item-sub {\n  color: #cbd5e1;\n}\n\n.dark [data-testid=\"header\"] .header-item:hover {\n  background: rgba(99, 102, 241, 0.18);\n}\n\n.dark [data-testid=\"header\"] .header-item-title,\n.dark [data-testid=\"header\"] .header-popover-title,\n.dark [data-testid=\"header\"] .header-date-pill {\n  color: #f8fafc;\n}\n\n.dark [data-testid=\"header\"] .header-item {\n  color: #f1f5f9;\n}\n\n.header-kicker,\n.header-date-pill,\n.header-icon-btn,\n.header-search-results,\n.header-popover {\n  animation: phaseSectionIn 420ms cubic-bezier(0.2, 0.9, 0.2, 1) both;\n}\n\n.header-kicker { animation-delay: 60ms; }\n.header-search-results { animation-delay: 120ms; }\n.header-date-pill { animation-delay: 180ms; }\n.header-icon-btn { animation-delay: 220ms; }\n.header-popover { animation-delay: 80ms; }\n\n.dark [data-testid=\"login-page\"] .login-shell {\n  background: rgba(17, 20, 29, 0.78);\n  border-color: rgba(59, 130, 246, 0.12);\n  box-shadow: 0 28px 80px rgba(0, 0, 0, 0.28);\n}\n\n.dark [data-testid=\"login-page\"] .login-panel {\n  background: rgba(20, 24, 33, 0.92);\n}\n\n.dark [data-testid=\"login-page\"] .login-title {\n  color: #f8fafc;\n}\n\n.dark [data-testid=\"login-page\"] .login-copy {\n  color: #94a3b8;\n}\n\n.dark [data-testid=\"login-page\"] .login-card {\n  background: rgba(23, 27, 37, 0.92);\n  border-color: rgba(255, 255, 255, 0.08);\n}\n\n.ai-sparkle {\n  animation: sparkleSpin 2.6s linear infinite;\n}\n\n.heatmap-threshold-bg {\n  background:\n    linear-gradient(135deg, rgba(34, 197, 94, 0.12) 0%, rgba(59, 130, 246, 0.14) 48%, rgba(239, 68, 68, 0.12) 100%),\n    linear-gradient(180deg, rgba(255, 255, 255, 0.6), rgba(224, 242, 254, 0.35));\n  border: 1px solid rgba(147, 197, 253, 0.45);\n}\n\n.quick-actions-panel {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.quick-actions-item {\n  width: 100%;\n  text-align: left;\n  border: 1px solid rgba(235, 194, 160, 0.5);\n  background: rgba(255, 252, 248, 0.88);\n  border-radius: 14px;\n  padding: 8px;\n  animation: rowIn 420ms ease both;\n  animation-delay: var(--qa-delay, 0ms);\n  transition: transform 170ms ease, box-shadow 170ms ease;\n}\n\n.quick-actions-item:hover {\n  transform: translateX(4px);\n  box-shadow: 0 8px 18px rgba(15, 23, 42, 0.1);\n}\n\n.quick-actions-track {\n  height: 6px;\n  border-radius: 999px;\n  margin-top: 6px;\n  background: #e2e8f0;\n  overflow: hidden;\n}\n\n.quick-actions-fill {\n  height: 100%;\n  border-radius: 999px;\n  background: linear-gradient(90deg, #2563eb, #60a5fa);\n  animation: progressGrow 900ms cubic-bezier(0.2, 0.8, 0.2, 1) both;\n}\n\n.agent-scanning {\n  letter-spacing: 0.02em;\n}\n\n.assistant-overlay {\n  border: 1px solid rgba(37, 99, 235, 0.22);\n  border-radius: 16px;\n  background: linear-gradient(135deg, rgba(238, 242, 255, 0.97), rgba(224, 242, 254, 0.96));\n  padding: 10px;\n  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.8);\n}\n\n.assistant-task-row {\n  animation: rowIn 420ms ease both;\n  animation-delay: var(--task-delay, 0ms);\n}\n\n.assistant-task-track {\n  height: 5px;\n  border-radius: 999px;\n  background: #bfdbfe;\n  overflow: hidden;\n  margin-top: 4px;\n}\n\n.assistant-task-fill {\n  height: 100%;\n  border-radius: 999px;\n  background: linear-gradient(90deg, #2563eb, #60a5fa);\n  animation: progressGrow 800ms cubic-bezier(0.2, 0.8, 0.2, 1) both;\n}\n\n.assistant-overlay-card {\n  background: linear-gradient(145deg, rgba(236, 253, 245, 0.95), rgba(239, 246, 255, 0.98));\n  box-shadow: 0 8px 18px rgba(15, 23, 42, 0.08);\n}\n\n.typing-dots::after {\n  content: \"...\";\n  display: inline-block;\n  width: 12px;\n  overflow: hidden;\n  vertical-align: bottom;\n  animation: typingDots 1.1s steps(4, end) infinite;\n}\n\n/* Keyframes */\n@keyframes orbFloat {\n  from { transform: translateY(-8px) scale(1); }\n  to { transform: translateY(10px) scale(1.05); }\n}\n\n@keyframes particlesDrift {\n  from { transform: translateY(0); }\n  to { transform: translateY(-20px); }\n}\n\n@keyframes navItemIn {\n  from { opacity: 0; transform: translateX(-10px); }\n  to { opacity: 1; transform: translateX(0); }\n}\n\n@keyframes sidebarIn {\n  from { opacity: 0; transform: translateX(-16px); }\n  to { opacity: 1; transform: translateX(0); }\n}\n\n@keyframes metricIn {\n  from { opacity: 0; transform: translateY(18px) scale(0.98); }\n  to { opacity: 1; transform: translateY(0) scale(1); }\n}\n\n@keyframes rowIn {\n  from { opacity: 0; transform: translateY(8px); }\n  to { opacity: 1; transform: translateY(0); }\n}\n\n@keyframes progressGrow {\n  from { transform: scaleX(0); }\n  to { transform: scaleX(1); }\n}\n\n@keyframes phasePageIn {\n  from { opacity: 0; transform: translateY(18px) scale(0.99); }\n  to { opacity: 1; transform: translateY(0) scale(1); }\n}\n\n@keyframes phaseSectionIn {\n  from { opacity: 0; transform: translateY(14px); }\n  to { opacity: 1; transform: translateY(0); }\n}\n\n@keyframes phaseDotIn {\n  from { opacity: 0; transform: scale(0.82); }\n  to { opacity: 1; transform: scale(1); }\n}\n\n@keyframes currentPhasePulse {\n  0%, 100% {\n    box-shadow: 0 0 0 6px rgba(99, 102, 241, 0.12), 0 0 22px rgba(99, 102, 241, 0.26);\n  }\n  50% {\n    box-shadow: 0 0 0 9px rgba(99, 102, 241, 0.08), 0 0 28px rgba(45, 212, 191, 0.24);\n  }\n}\n\n@keyframes heroGradientDrift {\n  from { background-position: 0% 0%, 0% 0%, 0% 0%; }\n  to { background-position: 5% 8%, -4% 4%, 100% 100%; }\n}\n\n@keyframes messageSlideIn {\n  from { opacity: 0; transform: translateY(18px) scale(0.96); }\n  to { opacity: 1; transform: translateY(0) scale(1); }\n}\n\n@keyframes messageShimmer {\n  0% { transform: translateX(-125%); }\n  45%, 100% { transform: translateX(125%); }\n}\n\n@keyframes typingBounce {\n  0%, 80%, 100% { transform: translateY(0); opacity: 0.45; }\n  40% { transform: translateY(-4px); opacity: 1; }\n}\n\n@keyframes sendPulse {\n  0%, 100% { box-shadow: 0 12px 28px rgba(99, 102, 241, 0.34); }\n  50% { box-shadow: 0 16px 36px rgba(45, 212, 191, 0.26); }\n}\n\n@keyframes scanSweep {\n  0% { transform: translateX(-120%); }\n  55%, 100% { transform: translateX(120%); }\n}\n\n@keyframes bellPulse {\n  0%, 100% { opacity: 0.9; transform: scale(1); }\n  50% { opacity: 0.45; transform: scale(0.84); }\n}\n\n@keyframes floatBtnIn {\n  from { opacity: 0; transform: translateY(24px) scale(0.92); }\n  to { opacity: 1; transform: translateY(0) scale(1); }\n}\n\n@keyframes sparkleSpin {\n  from { transform: rotate(0deg); }\n  to { transform: rotate(360deg); }\n}\n\n@keyframes typingDots {\n  0% { width: 0; }\n  100% { width: 12px; }\n}\n\n@keyframes healthPulse {\n  0% {\n    transform: scale(1);\n    box-shadow: 0 0 0 0 var(--pulse-color, rgba(148, 163, 184, 0.4));\n  }\n  70% {\n    transform: scale(1.02);\n    box-shadow: 0 0 0 7px transparent;\n  }\n  100% {\n    transform: scale(1);\n    box-shadow: 0 0 0 0 transparent;\n  }\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .ambient-orb,\n  .ambient-particles,\n  .sidebar-nav-item,\n  .metric-card-anim,\n  .table-row-anim,\n  .progress-anim,\n  .notification-pulse,\n  .floating-ai-btn,\n  .ai-sparkle,\n  .phase-step-dot,\n  .phase-step-line::after,\n  [data-testid^=\"phase-\"],\n  [data-testid^=\"phase-\"] > *,\n  .phase7-hero,\n  .phase7-console-card,\n  .phase7-control-row,\n  .phase7-progress-card,\n  .header-kicker,\n  .header-date-pill,\n  .header-icon-btn,\n  .header-search-results,\n  .header-popover,\n  .audit-card,\n  .copilot-message-row,\n  .copilot-user-message::after,\n  .copilot-send-armed,\n  .copilot-send-armed::after,\n  .copilot-typing-dots span,\n  .progress-bar-indicator::after,\n  .hero-progress-fill::after,\n  .quick-actions-fill::after,\n  .assistant-task-fill::after {\n    animation: none !important;\n    transition: none !important;\n  }\n}\n\n@media (max-width: 1280px) {\n  .audit-layout {\n    grid-template-columns: 13rem 1fr 18.5rem;\n  }\n}\n\n@media (max-width: 1100px) {\n  .audit-layout,\n  .audit-layout.chat-closed {\n    grid-template-columns: 12rem 1fr;\n  }\n\n  .audit-chat {\n    display: none;\n  }\n\n  .audit-sidebar .sidebar-nav-item {\n    padding-left: 1rem;\n  }\n\n  .audit-sidebar .sidebar-stepper::before {\n    display: none;\n  }\n}\n\n@media (max-width: 860px) {\n  .audit-layout,\n  .audit-layout.chat-closed {\n    grid-template-columns: 1fr;\n    grid-template-rows: auto auto 1fr;\n    height: auto;\n    min-height: 100vh;\n    overflow: auto;\n  }\n\n  .audit-sidebar {\n    grid-row: 1;\n    grid-column: 1;\n  }\n\n  .audit-header {\n    grid-row: 2;\n    grid-column: 1;\n  }\n\n  .audit-main {\n    grid-row: 3;\n    grid-column: 1;\n    min-height: 0;\n  }\n\n  .audit-sidebar {\n    height: auto;\n  }\n\n  .audit-brand {\n    padding-top: 0.9rem;\n    padding-bottom: 0.9rem;\n  }\n\n  .audit-panel {\n    padding: 0.75rem;\n  }\n\n  .floating-ai-btn {\n    right: 0.8rem;\n    bottom: 0.8rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
